var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField2 = (obj, key, value) => __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
const canUseDOM$1 = () => {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
const listenForCmpUpdates = (callback) => {
  const events = ["alma_cmp_v2_has_optedin"];
  const onCmpUpdate = (event) => {
    const data = event;
    if ((data == null ? void 0 : data.detail) !== void 0) {
      const consents = data.detail;
      callback(consents);
    }
  };
  for (const event of events) {
    window.addEventListener(event, onCmpUpdate, false);
  }
  return () => {
    for (const event of events) {
      window.removeEventListener(event, onCmpUpdate, false);
    }
  };
};
const getCmpRawData = (timeout = 0) => {
  return new Promise((resolve) => {
    let resolved = false;
    const events = [
      "alma_cmp_v2_consents_available_repetitive",
      "alma_b2b_consent_available_repetitive"
    ];
    const onCmpAvailable = (event) => {
      for (const event2 of events) {
        window.removeEventListener(event2, onCmpAvailable, false);
      }
      resolved = true;
      const data = event;
      if ((data == null ? void 0 : data.detail) !== void 0) {
        const consents = data.detail;
        return resolve(consents);
      }
      resolve(null);
    };
    for (const event of events) {
      window.addEventListener(event, onCmpAvailable, false);
    }
    if (timeout) {
      setTimeout(() => {
        if (resolved) return;
        for (const event of events) {
          window.removeEventListener(event, onCmpAvailable, false);
        }
        resolve(null);
      }, timeout);
    }
  });
};
const isB2bCmpData = (data) => {
  return data === true || data === false;
};
const isB2cCmpData = (data) => {
  return data.standard !== void 0;
};
const parseAccountUniversalConsents = (consents, defaultConsents) => {
  const accountConsents = { ...defaultConsents };
  if (isB2bCmpData(consents)) {
    const keys = Object.keys(accountConsents);
    for (const t2 of keys) {
      accountConsents[t2] = consents;
    }
  } else if (isB2cCmpData(consents)) {
    const requiredConsents = {
      // v2
      standard: {
        standard: [1]
      },
      ga: {
        standard: [1],
        nonTCFVendors: [3]
      },
      // v2 & v3
      facebook: {
        specialFeature: [1, 2],
        nonTCFVendors: [1]
      },
      google: {
        nonTCFVendors: [3]
      },
      apple: {
        nonTCFVendors: [27]
      },
      linkedin: {
        nonTCFVendors: [15]
      }
    };
    const targets = Object.keys(requiredConsents);
    for (const target of targets) {
      const consentTypes = Object.keys(requiredConsents[target]);
      let allRequiredConsentsGiven = true;
      for (const type of consentTypes) {
        const userConsents = consents == null ? void 0 : consents[type];
        const required = requiredConsents[target][type];
        for (const id of required) {
          if (!(userConsents == null ? void 0 : userConsents[id])) {
            allRequiredConsentsGiven = false;
            break;
          }
        }
        if (!allRequiredConsentsGiven) break;
      }
      accountConsents[target] = allRequiredConsentsGiven;
    }
  }
  return accountConsents;
};
const _AlmaAccountCmpHandler = class _AlmaAccountCmpHandler2 {
  constructor() {
    __publicField2(this, "cmpAvailable", false);
    __publicField2(this, "cleanupListener", null);
    __publicField2(this, "universalConsents", {
      standard: false,
      ga: false,
      facebook: false,
      google: false,
      apple: false,
      linkedin: false
    });
    __publicField2(this, "updateUniversalConsents", (consents) => {
      if (consents !== null) {
        this.cmpAvailable = true;
        const update = parseAccountUniversalConsents(consents, this.universalConsents);
        this.universalConsents = update;
      }
    });
    __publicField2(this, "cleanupExistingListener", () => {
      if (this.cleanupListener) {
        this.cleanupListener();
        this.cleanupListener = null;
      }
    });
  }
  /**
   * Returns Alma account universal compatible consent object.
   * Includes a timeout mechanism to handle slow CMP initialization scenarios.
   *
   * @param options - Configuration options
   * @param options.timeout - Optional timeout in milliseconds to wait for CMP initialization
   * @returns {Promise<AccountUniversalConsents>} Promise containing the consent object
   * @throws {Error} When CMP data cannot be retrieved
   * @see AlmaAccountCmpHandler#updateUniversalConsents
   */
  async getConsents(options) {
    const isCmpAvailable = this.cmpAvailable;
    if (!isCmpAvailable && (options == null ? void 0 : options.timeout)) {
      try {
        const consents = await getCmpRawData(options.timeout);
        if (!_AlmaAccountCmpHandler2.instance) {
          return this.universalConsents;
        }
        if (consents !== null) {
          this.updateUniversalConsents(consents);
          await new Promise((resolve) => setTimeout(resolve, 50));
        } else {
        }
      } catch (error) {
        throw error;
      }
    }
    return this.universalConsents;
  }
};
__publicField2(_AlmaAccountCmpHandler, "instance", null);
__publicField2(_AlmaAccountCmpHandler, "getInstance", () => {
  if (!canUseDOM$1()) {
    return null;
  }
  if (!_AlmaAccountCmpHandler.instance) {
    _AlmaAccountCmpHandler.instance = new _AlmaAccountCmpHandler();
    getCmpRawData().then((consents) => {
      if (_AlmaAccountCmpHandler.instance) {
        _AlmaAccountCmpHandler.instance.updateUniversalConsents(consents);
        _AlmaAccountCmpHandler.instance.cleanupExistingListener();
        _AlmaAccountCmpHandler.instance.cleanupListener = listenForCmpUpdates(
          _AlmaAccountCmpHandler.instance.updateUniversalConsents
        );
      }
    }).catch((error) => {
      if (_AlmaAccountCmpHandler.instance) {
        _AlmaAccountCmpHandler.instance.cleanupExistingListener();
      }
    });
  }
  return _AlmaAccountCmpHandler.instance;
});
__publicField2(_AlmaAccountCmpHandler, "destroy", () => {
  var _a;
  if ((_a = _AlmaAccountCmpHandler.instance) == null ? void 0 : _a.cleanupListener) {
    _AlmaAccountCmpHandler.instance.cleanupListener();
  }
  _AlmaAccountCmpHandler.instance = null;
});
let AlmaAccountCmpHandler = _AlmaAccountCmpHandler;
var u$1 = Object.defineProperty;
var L$1 = (t2, e2, r2) => e2 in t2 ? u$1(t2, e2, { enumerable: true, configurable: true, writable: true, value: r2 }) : t2[e2] = r2;
var n$1 = (t2, e2, r2) => L$1(t2, typeof e2 != "symbol" ? e2 + "" : e2, r2);
var i$1 = /* @__PURE__ */ ((t2) => (t2.ALMA_BRAND = "MediumOrchid", t2.MODULE_VERSION = "SlateGray", t2.MESSAGE_CONTEXT = "DarkSlateGray", t2.BLACK = "Black", t2.WHITE = "White", t2))(i$1 || {}), h$1 = /* @__PURE__ */ ((t2) => (t2.GEO_CLIENT = "GeoClient", t2.CMP_CLIENT = "ConsentClient", t2.ACCOUNT_ANALYTICS = "AccountAnalytics", t2.ACCOUNT_CORE = "AccountCore", t2.TUNNUS_PRELOGIN = "TunnusPrelogin", t2.SAMMIO_SENDER = "SammioSender", t2.RESERVATION_1 = "Reservation1", t2.RESERVATION_2 = "Reservation2", t2.RESERVATION_3 = "Reservation3", t2.RESERVATION_4 = "Reservation4", t2))(h$1 || {});
const E$1 = {
  GeoClient: "MediumSpringGreen",
  ConsentClient: "MistyRose",
  AccountAnalytics: "DodgerBlue",
  AccountCore: "DeepSkyBlue",
  TunnusPrelogin: "CornflowerBlue",
  SammioSender: "Yellow",
  Reservation1: "HotPink",
  Reservation2: "DeepPink",
  Reservation3: "DarkKhaki",
  Reservation4: "Aqua"
}, a$1 = {
  "font-weight": "900",
  padding: "2px 0.5em 2px 0.5em",
  color: i$1.BLACK
};
function O$1(t2) {
  const e2 = E$1[t2];
  return {
    companyName: {
      ...a$1,
      color: i$1.WHITE,
      "background-color": i$1.ALMA_BRAND
    },
    AlmaModuleName: {
      ...a$1,
      color: i$1.BLACK,
      "background-color": e2
    },
    moduleVersion: {
      ...a$1,
      color: i$1.WHITE,
      "background-color": i$1.MODULE_VERSION
    },
    messageContext: {
      ...a$1,
      color: i$1.WHITE,
      "background-color": i$1.MESSAGE_CONTEXT
    }
  };
}
const l$1 = (t2) => Object.keys(t2).map((e2) => `${e2}: ${t2[e2]};`).join(" ");
function S$1(t2) {
  if (t2.enableLogPrefix !== true)
    return t2.args;
  const e2 = O$1(t2.AlmaModuleName);
  let r2 = `%c${t2.companyName}%c${t2.AlmaModuleName}`;
  const s2 = [
    l$1(e2.companyName),
    l$1(e2.AlmaModuleName)
  ];
  return typeof t2.moduleVersion == "string" && (r2 = `${r2}%c${t2.moduleVersion}`, s2.push(l$1(e2.moduleVersion))), typeof t2.messageContext == "string" && (r2 = `${r2}%c${t2.messageContext}`, s2.push(l$1(e2.messageContext))), [r2, ...s2, ...t2.args];
}
const o$1 = class o {
  constructor(e2, r2) {
    n$1(this, "companyName");
    n$1(this, "AlmaModuleName");
    n$1(this, "moduleVersion");
    n$1(this, "moduleColor");
    this.companyName = "ALMA", this.AlmaModuleName = e2, this.moduleColor = E$1[e2], r2 != null && r2.moduleVersion && this.validateModuleVersion(r2.moduleVersion) && (this.moduleVersion = r2.moduleVersion), this.registerGlobalToggles();
  }
  validateModuleVersion(e2) {
    if (typeof e2 > "u") return false;
    if (/dev|development/gi.test(e2) || /^v\d+$/.test(e2) === true || /^v\d+\.\d+\.\d+.*/.test(e2) === true) return true;
    throw new Error(`Invalid moduleVersion given: ${e2}`);
  }
  registerGlobalToggles() {
    window.ALMA = window.ALMA || {}, window.ALMA.moduleLoggerV1 = window.ALMA.moduleLoggerV1 || {
      toggle: this.toggleLogs,
      prefixes: this.toggleLogPrefixes
    };
  }
  areLogsEnabled() {
    try {
      return window.localStorage.getItem(o.LOGS_TOGGLE_KEY) === "true";
    } catch {
      return false;
    }
  }
  toggleLogs() {
    try {
      const e2 = window.localStorage.getItem(o.LOGS_TOGGLE_KEY) !== "true";
      return window.localStorage.setItem(
        o.LOGS_TOGGLE_KEY,
        String(e2)
      ), e2;
    } catch (e2) {
      return console.error("Could not toggle logs", e2), false;
    }
  }
  areLogPrefixDisabled() {
    try {
      return window.localStorage.getItem(o.LOGS_PREFIX_TOGGLE_KEY) === "true";
    } catch {
      return false;
    }
  }
  toggleLogPrefixes() {
    try {
      const e2 = window.localStorage.getItem(o.LOGS_PREFIX_TOGGLE_KEY) !== "true";
      return window.localStorage.setItem(
        o.LOGS_PREFIX_TOGGLE_KEY,
        String(e2)
      ), e2;
    } catch (e2) {
      return console.error("Could not toggle log prefix setting", e2), true;
    }
  }
  logger(e2, r2, ...s2) {
    if (window.console && (this.areLogsEnabled() || e2 === "critical")) {
      const g2 = S$1({
        enableLogPrefix: !this.areLogPrefixDisabled(),
        companyName: this.companyName,
        AlmaModuleName: this.AlmaModuleName,
        moduleVersion: this.moduleVersion,
        messageContext: r2,
        args: s2
      }), d2 = e2 === "critical" ? "error" : e2;
      window.console[d2](...g2);
    }
  }
  debug(...e2) {
    this.logger("debug", void 0, ...e2);
  }
  info(...e2) {
    this.logger("info", void 0, ...e2);
  }
  trace(...e2) {
    this.logger("trace", void 0, ...e2);
  }
  warn(...e2) {
    this.logger("warn", void 0, ...e2);
  }
  error(...e2) {
    this.logger("error", void 0, ...e2);
  }
  critical(...e2) {
    this.logger("critical", void 0, ...e2);
  }
  debugWithContext(e2, ...r2) {
    this.logger("debug", e2, ...r2);
  }
  infoWithContext(e2, ...r2) {
    this.logger("info", e2, ...r2);
  }
  traceWithContext(e2, ...r2) {
    this.logger("trace", e2, ...r2);
  }
  warnWithContext(e2, ...r2) {
    this.logger("warn", e2, ...r2);
  }
  errorWithContext(e2, ...r2) {
    this.logger("error", e2, ...r2);
  }
  criticalWithContext(e2, ...r2) {
    this.logger("critical", e2, ...r2);
  }
};
n$1(o$1, "LOCALSTORAGE_PREFIX", "ALMA_CROSS_SITE_LOGGER"), n$1(o$1, "LOGS_TOGGLE_KEY", `${o$1.LOCALSTORAGE_PREFIX}_ENABLED`), n$1(o$1, "LOGS_PREFIX_TOGGLE_KEY", `${o$1.LOCALSTORAGE_PREFIX}_PREFIXED`);
let c$1 = o$1;
function e(e2, t2) {
  var i2 = {};
  for (var o3 in e2) Object.prototype.hasOwnProperty.call(e2, o3) && t2.indexOf(o3) < 0 && (i2[o3] = e2[o3]);
  if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) {
    var n2 = 0;
    for (o3 = Object.getOwnPropertySymbols(e2); n2 < o3.length; n2++) t2.indexOf(o3[n2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, o3[n2]) && (i2[o3[n2]] = e2[o3[n2]]);
  }
  return i2;
}
"function" == typeof SuppressedError && SuppressedError;
var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function i(e2) {
  return e2 && e2.__esModule && Object.prototype.hasOwnProperty.call(e2, "default") ? e2.default : e2;
}
function o2(e2, t2) {
  return e2(t2 = { exports: {} }, t2.exports), t2.exports;
}
var n = o2(function(e2, t2) {
  Object.defineProperty(t2, "__esModule", { value: true });
  var i2 = function() {
    function e3() {
      var e4 = this;
      this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(t3, i3) {
        var o3 = e4.locked.get(t3);
        void 0 === o3 ? void 0 === i3 ? e4.locked.set(t3, []) : e4.locked.set(t3, [i3]) : void 0 !== i3 && (o3.unshift(i3), e4.locked.set(t3, o3));
      }, this.isLocked = function(t3) {
        return e4.locked.has(t3);
      }, this.lock = function(t3) {
        return new Promise(function(i3, o3) {
          e4.isLocked(t3) ? e4.addToLocked(t3, i3) : (e4.addToLocked(t3), i3());
        });
      }, this.unlock = function(t3) {
        var i3 = e4.locked.get(t3);
        if (void 0 !== i3 && 0 !== i3.length) {
          var o3 = i3.pop();
          e4.locked.set(t3, i3), void 0 !== o3 && setTimeout(o3, 0);
        } else e4.locked.delete(t3);
      };
    }
    return e3.getInstance = function() {
      return void 0 === e3.instance && (e3.instance = new e3()), e3.instance;
    }, e3;
  }();
  t2.default = function() {
    return i2.getInstance();
  };
});
i(n);
var a = i(o2(function(e2, i2) {
  var o3 = t && t.__awaiter || function(e3, t2, i3, o4) {
    return new (i3 || (i3 = Promise))(function(n2, a3) {
      function r3(e4) {
        try {
          c3(o4.next(e4));
        } catch (e5) {
          a3(e5);
        }
      }
      function s3(e4) {
        try {
          c3(o4.throw(e4));
        } catch (e5) {
          a3(e5);
        }
      }
      function c3(e4) {
        e4.done ? n2(e4.value) : new i3(function(t3) {
          t3(e4.value);
        }).then(r3, s3);
      }
      c3((o4 = o4.apply(e3, t2 || [])).next());
    });
  }, a2 = t && t.__generator || function(e3, t2) {
    var i3, o4, n2, a3, r3 = { label: 0, sent: function() {
      if (1 & n2[0]) throw n2[1];
      return n2[1];
    }, trys: [], ops: [] };
    return a3 = { next: s3(0), throw: s3(1), return: s3(2) }, "function" == typeof Symbol && (a3[Symbol.iterator] = function() {
      return this;
    }), a3;
    function s3(a4) {
      return function(s4) {
        return function(a5) {
          if (i3) throw new TypeError("Generator is already executing.");
          for (; r3; ) try {
            if (i3 = 1, o4 && (n2 = 2 & a5[0] ? o4.return : a5[0] ? o4.throw || ((n2 = o4.return) && n2.call(o4), 0) : o4.next) && !(n2 = n2.call(o4, a5[1])).done) return n2;
            switch (o4 = 0, n2 && (a5 = [2 & a5[0], n2.value]), a5[0]) {
              case 0:
              case 1:
                n2 = a5;
                break;
              case 4:
                return r3.label++, { value: a5[1], done: false };
              case 5:
                r3.label++, o4 = a5[1], a5 = [0];
                continue;
              case 7:
                a5 = r3.ops.pop(), r3.trys.pop();
                continue;
              default:
                if (!(n2 = r3.trys, (n2 = n2.length > 0 && n2[n2.length - 1]) || 6 !== a5[0] && 2 !== a5[0])) {
                  r3 = 0;
                  continue;
                }
                if (3 === a5[0] && (!n2 || a5[1] > n2[0] && a5[1] < n2[3])) {
                  r3.label = a5[1];
                  break;
                }
                if (6 === a5[0] && r3.label < n2[1]) {
                  r3.label = n2[1], n2 = a5;
                  break;
                }
                if (n2 && r3.label < n2[2]) {
                  r3.label = n2[2], r3.ops.push(a5);
                  break;
                }
                n2[2] && r3.ops.pop(), r3.trys.pop();
                continue;
            }
            a5 = t2.call(e3, r3);
          } catch (e4) {
            a5 = [6, e4], o4 = 0;
          } finally {
            i3 = n2 = 0;
          }
          if (5 & a5[0]) throw a5[1];
          return { value: a5[0] ? a5[1] : void 0, done: true };
        }([a4, s4]);
      };
    }
  }, r2 = t;
  Object.defineProperty(i2, "__esModule", { value: true });
  var s2 = "browser-tabs-lock-key", c2 = { key: function(e3) {
    return o3(r2, void 0, void 0, function() {
      return a2(this, function(e4) {
        throw new Error("Unsupported");
      });
    });
  }, getItem: function(e3) {
    return o3(r2, void 0, void 0, function() {
      return a2(this, function(e4) {
        throw new Error("Unsupported");
      });
    });
  }, clear: function() {
    return o3(r2, void 0, void 0, function() {
      return a2(this, function(e3) {
        return [2, window.localStorage.clear()];
      });
    });
  }, removeItem: function(e3) {
    return o3(r2, void 0, void 0, function() {
      return a2(this, function(e4) {
        throw new Error("Unsupported");
      });
    });
  }, setItem: function(e3, t2) {
    return o3(r2, void 0, void 0, function() {
      return a2(this, function(e4) {
        throw new Error("Unsupported");
      });
    });
  }, keySync: function(e3) {
    return window.localStorage.key(e3);
  }, getItemSync: function(e3) {
    return window.localStorage.getItem(e3);
  }, clearSync: function() {
    return window.localStorage.clear();
  }, removeItemSync: function(e3) {
    return window.localStorage.removeItem(e3);
  }, setItemSync: function(e3, t2) {
    return window.localStorage.setItem(e3, t2);
  } };
  function d2(e3) {
    return new Promise(function(t2) {
      return setTimeout(t2, e3);
    });
  }
  function u2(e3) {
    for (var t2 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i3 = "", o4 = 0; o4 < e3; o4++) {
      i3 += t2[Math.floor(Math.random() * t2.length)];
    }
    return i3;
  }
  var l2 = function() {
    function e3(t2) {
      this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + u2(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t2, void 0 === e3.waiters && (e3.waiters = []);
    }
    return e3.prototype.acquireLock = function(t2, i3) {
      return void 0 === i3 && (i3 = 5e3), o3(this, void 0, void 0, function() {
        var o4, n2, r3, l3, h2, p2, m2;
        return a2(this, function(a3) {
          switch (a3.label) {
            case 0:
              o4 = Date.now() + u2(4), n2 = Date.now() + i3, r3 = s2 + "-" + t2, l3 = void 0 === this.storageHandler ? c2 : this.storageHandler, a3.label = 1;
            case 1:
              return Date.now() < n2 ? [4, d2(30)] : [3, 8];
            case 2:
              return a3.sent(), null !== l3.getItemSync(r3) ? [3, 5] : (h2 = this.id + "-" + t2 + "-" + o4, [4, d2(Math.floor(25 * Math.random()))]);
            case 3:
              return a3.sent(), l3.setItemSync(r3, JSON.stringify({ id: this.id, iat: o4, timeoutKey: h2, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, d2(30)];
            case 4:
              return a3.sent(), null !== (p2 = l3.getItemSync(r3)) && (m2 = JSON.parse(p2)).id === this.id && m2.iat === o4 ? (this.acquiredIatSet.add(o4), this.refreshLockWhileAcquired(r3, o4), [2, true]) : [3, 7];
            case 5:
              return e3.lockCorrector(void 0 === this.storageHandler ? c2 : this.storageHandler), [4, this.waitForSomethingToChange(n2)];
            case 6:
              a3.sent(), a3.label = 7;
            case 7:
              return o4 = Date.now() + u2(4), [3, 1];
            case 8:
              return [2, false];
          }
        });
      });
    }, e3.prototype.refreshLockWhileAcquired = function(e4, t2) {
      return o3(this, void 0, void 0, function() {
        var i3 = this;
        return a2(this, function(r3) {
          return setTimeout(function() {
            return o3(i3, void 0, void 0, function() {
              var i4, o4, r4;
              return a2(this, function(a3) {
                switch (a3.label) {
                  case 0:
                    return [4, n.default().lock(t2)];
                  case 1:
                    return a3.sent(), this.acquiredIatSet.has(t2) ? (i4 = void 0 === this.storageHandler ? c2 : this.storageHandler, null === (o4 = i4.getItemSync(e4)) ? (n.default().unlock(t2), [2]) : ((r4 = JSON.parse(o4)).timeRefreshed = Date.now(), i4.setItemSync(e4, JSON.stringify(r4)), n.default().unlock(t2), this.refreshLockWhileAcquired(e4, t2), [2])) : (n.default().unlock(t2), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, e3.prototype.waitForSomethingToChange = function(t2) {
      return o3(this, void 0, void 0, function() {
        return a2(this, function(i3) {
          switch (i3.label) {
            case 0:
              return [4, new Promise(function(i4) {
                var o4 = false, n2 = Date.now(), a3 = false;
                function r3() {
                  if (a3 || (window.removeEventListener("storage", r3), e3.removeFromWaiting(r3), clearTimeout(s3), a3 = true), !o4) {
                    o4 = true;
                    var t3 = 50 - (Date.now() - n2);
                    t3 > 0 ? setTimeout(i4, t3) : i4(null);
                  }
                }
                window.addEventListener("storage", r3), e3.addToWaiting(r3);
                var s3 = setTimeout(r3, Math.max(0, t2 - Date.now()));
              })];
            case 1:
              return i3.sent(), [2];
          }
        });
      });
    }, e3.addToWaiting = function(t2) {
      this.removeFromWaiting(t2), void 0 !== e3.waiters && e3.waiters.push(t2);
    }, e3.removeFromWaiting = function(t2) {
      void 0 !== e3.waiters && (e3.waiters = e3.waiters.filter(function(e4) {
        return e4 !== t2;
      }));
    }, e3.notifyWaiters = function() {
      void 0 !== e3.waiters && e3.waiters.slice().forEach(function(e4) {
        return e4();
      });
    }, e3.prototype.releaseLock = function(e4) {
      return o3(this, void 0, void 0, function() {
        return a2(this, function(t2) {
          switch (t2.label) {
            case 0:
              return [4, this.releaseLock__private__(e4)];
            case 1:
              return [2, t2.sent()];
          }
        });
      });
    }, e3.prototype.releaseLock__private__ = function(t2) {
      return o3(this, void 0, void 0, function() {
        var i3, o4, r3, d3;
        return a2(this, function(a3) {
          switch (a3.label) {
            case 0:
              return i3 = void 0 === this.storageHandler ? c2 : this.storageHandler, o4 = s2 + "-" + t2, null === (r3 = i3.getItemSync(o4)) ? [2] : (d3 = JSON.parse(r3)).id !== this.id ? [3, 2] : [4, n.default().lock(d3.iat)];
            case 1:
              a3.sent(), this.acquiredIatSet.delete(d3.iat), i3.removeItemSync(o4), n.default().unlock(d3.iat), e3.notifyWaiters(), a3.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, e3.lockCorrector = function(t2) {
      for (var i3 = Date.now() - 5e3, o4 = t2, n2 = [], a3 = 0; ; ) {
        var r3 = o4.keySync(a3);
        if (null === r3) break;
        n2.push(r3), a3++;
      }
      for (var c3 = false, d3 = 0; d3 < n2.length; d3++) {
        var u3 = n2[d3];
        if (u3.includes(s2)) {
          var l3 = o4.getItemSync(u3);
          if (null !== l3) {
            var h2 = JSON.parse(l3);
            (void 0 === h2.timeRefreshed && h2.timeAcquired < i3 || void 0 !== h2.timeRefreshed && h2.timeRefreshed < i3) && (o4.removeItemSync(u3), c3 = true);
          }
        }
      }
      c3 && e3.notifyWaiters();
    }, e3.waiters = void 0, e3;
  }();
  i2.default = l2;
}));
const r = { timeoutInSeconds: 60 }, s = { name: "auth0-spa-js", version: "2.1.3" }, c = () => Date.now();
class d extends Error {
  constructor(e2, t2) {
    super(t2), this.error = e2, this.error_description = t2, Object.setPrototypeOf(this, d.prototype);
  }
  static fromPayload({ error: e2, error_description: t2 }) {
    return new d(e2, t2);
  }
}
class u extends d {
  constructor(e2, t2, i2, o3 = null) {
    super(e2, t2), this.state = i2, this.appState = o3, Object.setPrototypeOf(this, u.prototype);
  }
}
class l extends d {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, l.prototype);
  }
}
class h extends l {
  constructor(e2) {
    super(), this.popup = e2, Object.setPrototypeOf(this, h.prototype);
  }
}
class p extends d {
  constructor(e2) {
    super("cancelled", "Popup closed"), this.popup = e2, Object.setPrototypeOf(this, p.prototype);
  }
}
class m extends d {
  constructor(e2, t2, i2) {
    super(e2, t2), this.mfa_token = i2, Object.setPrototypeOf(this, m.prototype);
  }
}
class f extends d {
  constructor(e2, t2) {
    super("missing_refresh_token", `Missing Refresh Token (audience: '${g(e2, ["default"])}', scope: '${g(t2)}')`), this.audience = e2, this.scope = t2, Object.setPrototypeOf(this, f.prototype);
  }
}
function g(e2, t2 = []) {
  return e2 && !t2.includes(e2) ? e2 : "";
}
const w = () => window.crypto, y = () => {
  const e2 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let t2 = "";
  return Array.from(w().getRandomValues(new Uint8Array(43))).forEach((i2) => t2 += e2[i2 % e2.length]), t2;
}, k = (e2) => btoa(e2), v = (t2) => {
  var { clientId: i2 } = t2, o3 = e(t2, ["clientId"]);
  return new URLSearchParams(((e2) => Object.keys(e2).filter((t3) => void 0 !== e2[t3]).reduce((t3, i3) => Object.assign(Object.assign({}, t3), { [i3]: e2[i3] }), {}))(Object.assign({ client_id: i2 }, o3))).toString();
}, b = (e2) => ((e3) => decodeURIComponent(atob(e3).split("").map((e4) => "%" + ("00" + e4.charCodeAt(0).toString(16)).slice(-2)).join("")))(e2.replace(/_/g, "/").replace(/-/g, "+")), _ = async (e2, t2) => {
  const i2 = await fetch(e2, t2);
  return { ok: i2.ok, json: await i2.json() };
}, I = async (e2, t2, i2) => {
  const o3 = new AbortController();
  let n2;
  return t2.signal = o3.signal, Promise.race([_(e2, t2), new Promise((e3, t3) => {
    n2 = setTimeout(() => {
      o3.abort(), t3(new Error("Timeout when executing 'fetch'"));
    }, i2);
  })]).finally(() => {
    clearTimeout(n2);
  });
}, S = async (e2, t2, i2, o3, n2, a2, r2) => {
  return s2 = { auth: { audience: t2, scope: i2 }, timeout: n2, fetchUrl: e2, fetchOptions: o3, useFormData: r2 }, c2 = a2, new Promise(function(e3, t3) {
    const i3 = new MessageChannel();
    i3.port1.onmessage = function(o4) {
      o4.data.error ? t3(new Error(o4.data.error)) : e3(o4.data), i3.port1.close();
    }, c2.postMessage(s2, [i3.port2]);
  });
  var s2, c2;
}, O = async (e2, t2, i2, o3, n2, a2, r2 = 1e4) => n2 ? S(e2, t2, i2, o3, r2, n2, a2) : I(e2, o3, r2);
async function T(t2, i2) {
  var { baseUrl: o3, timeout: n2, audience: a2, scope: r2, auth0Client: c2, useFormData: u2 } = t2, l2 = e(t2, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
  const h2 = u2 ? v(l2) : JSON.stringify(l2);
  return await async function(t3, i3, o4, n3, a3, r3, s2) {
    let c3, u3 = null;
    for (let e2 = 0; e2 < 3; e2++) try {
      c3 = await O(t3, o4, n3, a3, r3, s2, i3), u3 = null;
      break;
    } catch (e3) {
      u3 = e3;
    }
    if (u3) throw u3;
    const l3 = c3.json, { error: h3, error_description: p2 } = l3, g2 = e(l3, ["error", "error_description"]), { ok: w2 } = c3;
    if (!w2) {
      const e2 = p2 || `HTTP error. Unable to fetch ${t3}`;
      if ("mfa_required" === h3) throw new m(h3, e2, g2.mfa_token);
      if ("missing_refresh_token" === h3) throw new f(o4, n3);
      throw new d(h3 || "request_error", e2);
    }
    return g2;
  }(`${o3}/oauth/token`, n2, a2 || "default", r2, { method: "POST", body: h2, headers: { "Content-Type": u2 ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(c2 || s)) } }, i2, u2);
}
const j = (...e2) => {
  return (t2 = e2.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t2))).join(" ");
  var t2;
};
class C {
  constructor(e2, t2 = "@@auth0spajs@@", i2) {
    this.prefix = t2, this.suffix = i2, this.clientId = e2.clientId, this.scope = e2.scope, this.audience = e2.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(e2) {
    const [t2, i2, o3, n2] = e2.split("::");
    return new C({ clientId: i2, scope: n2, audience: o3 }, t2);
  }
  static fromCacheEntry(e2) {
    const { scope: t2, audience: i2, client_id: o3 } = e2;
    return new C({ scope: t2, audience: i2, clientId: o3 });
  }
}
class z {
  set(e2, t2) {
    localStorage.setItem(e2, JSON.stringify(t2));
  }
  get(e2) {
    const t2 = window.localStorage.getItem(e2);
    if (t2) try {
      return JSON.parse(t2);
    } catch (e3) {
      return;
    }
  }
  remove(e2) {
    localStorage.removeItem(e2);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter((e2) => e2.startsWith("@@auth0spajs@@"));
  }
}
class P {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ function() {
      let e2 = {};
      return { set(t2, i2) {
        e2[t2] = i2;
      }, get(t2) {
        const i2 = e2[t2];
        if (i2) return i2;
      }, remove(t2) {
        delete e2[t2];
      }, allKeys: () => Object.keys(e2) };
    }();
  }
}
class x {
  constructor(e2, t2, i2) {
    this.cache = e2, this.keyManifest = t2, this.nowProvider = i2 || c;
  }
  async setIdToken(e2, t2, i2) {
    var o3;
    const n2 = this.getIdTokenCacheKey(e2);
    await this.cache.set(n2, { id_token: t2, decodedToken: i2 }), await (null === (o3 = this.keyManifest) || void 0 === o3 ? void 0 : o3.add(n2));
  }
  async getIdToken(e2) {
    const t2 = await this.cache.get(this.getIdTokenCacheKey(e2.clientId));
    if (!t2 && e2.scope && e2.audience) {
      const t3 = await this.get(e2);
      if (!t3) return;
      if (!t3.id_token || !t3.decodedToken) return;
      return { id_token: t3.id_token, decodedToken: t3.decodedToken };
    }
    if (t2) return { id_token: t2.id_token, decodedToken: t2.decodedToken };
  }
  async get(e2, t2 = 0) {
    var i2;
    let o3 = await this.cache.get(e2.toKey());
    if (!o3) {
      const t3 = await this.getCacheKeys();
      if (!t3) return;
      const i3 = this.matchExistingCacheKey(e2, t3);
      i3 && (o3 = await this.cache.get(i3));
    }
    if (!o3) return;
    const n2 = await this.nowProvider(), a2 = Math.floor(n2 / 1e3);
    return o3.expiresAt - t2 < a2 ? o3.body.refresh_token ? (o3.body = { refresh_token: o3.body.refresh_token }, await this.cache.set(e2.toKey(), o3), o3.body) : (await this.cache.remove(e2.toKey()), void await (null === (i2 = this.keyManifest) || void 0 === i2 ? void 0 : i2.remove(e2.toKey()))) : o3.body;
  }
  async set(e2) {
    var t2;
    const i2 = new C({ clientId: e2.client_id, scope: e2.scope, audience: e2.audience }), o3 = await this.wrapCacheEntry(e2);
    await this.cache.set(i2.toKey(), o3), await (null === (t2 = this.keyManifest) || void 0 === t2 ? void 0 : t2.add(i2.toKey()));
  }
  async clear(e2) {
    var t2;
    const i2 = await this.getCacheKeys();
    i2 && (await i2.filter((t3) => !e2 || t3.includes(e2)).reduce(async (e3, t3) => {
      await e3, await this.cache.remove(t3);
    }, Promise.resolve()), await (null === (t2 = this.keyManifest) || void 0 === t2 ? void 0 : t2.clear()));
  }
  async wrapCacheEntry(e2) {
    const t2 = await this.nowProvider();
    return { body: e2, expiresAt: Math.floor(t2 / 1e3) + e2.expires_in };
  }
  async getCacheKeys() {
    var e2;
    return this.keyManifest ? null === (e2 = await this.keyManifest.get()) || void 0 === e2 ? void 0 : e2.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(e2) {
    return new C({ clientId: e2 }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(e2, t2) {
    return t2.filter((t3) => {
      var i2;
      const o3 = C.fromKey(t3), n2 = new Set(o3.scope && o3.scope.split(" ")), a2 = (null === (i2 = e2.scope) || void 0 === i2 ? void 0 : i2.split(" ")) || [], r2 = o3.scope && a2.reduce((e3, t4) => e3 && n2.has(t4), true);
      return "@@auth0spajs@@" === o3.prefix && o3.clientId === e2.clientId && o3.audience === e2.audience && r2;
    })[0];
  }
}
class Z {
  constructor(e2, t2, i2) {
    this.storage = e2, this.clientId = t2, this.cookieDomain = i2, this.storageKey = `a0.spajs.txs.${this.clientId}`;
  }
  create(e2) {
    this.storage.save(this.storageKey, e2, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
}
const K = (e2) => "number" == typeof e2, W = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], E = (e2) => {
  if (!e2.id_token) throw new Error("ID token is required but missing");
  const t2 = ((e3) => {
    const t3 = e3.split("."), [i3, o4, n3] = t3;
    if (3 !== t3.length || !i3 || !o4 || !n3) throw new Error("ID token could not be decoded");
    const a2 = JSON.parse(b(o4)), r2 = { __raw: e3 }, s2 = {};
    return Object.keys(a2).forEach((e4) => {
      r2[e4] = a2[e4], W.includes(e4) || (s2[e4] = a2[e4]);
    }), { encoded: { header: i3, payload: o4, signature: n3 }, header: JSON.parse(b(i3)), claims: r2, user: s2 };
  })(e2.id_token);
  if (!t2.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (t2.claims.iss !== e2.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e2.iss}", found "${t2.claims.iss}"`);
  if (!t2.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
  if ("RS256" !== t2.header.alg) throw new Error(`Signature algorithm of "${t2.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
  if (!t2.claims.aud || "string" != typeof t2.claims.aud && !Array.isArray(t2.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(t2.claims.aud)) {
    if (!t2.claims.aud.includes(e2.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e2.aud}" but was not one of "${t2.claims.aud.join(", ")}"`);
    if (t2.claims.aud.length > 1) {
      if (!t2.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (t2.claims.azp !== e2.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e2.aud}", found "${t2.claims.azp}"`);
    }
  } else if (t2.claims.aud !== e2.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e2.aud}" but found "${t2.claims.aud}"`);
  if (e2.nonce) {
    if (!t2.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (t2.claims.nonce !== e2.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e2.nonce}", found "${t2.claims.nonce}"`);
  }
  if (e2.max_age && !K(t2.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (null == t2.claims.exp || !K(t2.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!K(t2.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const i2 = e2.leeway || 60, o3 = new Date(e2.now || Date.now()), n2 = /* @__PURE__ */ new Date(0);
  if (n2.setUTCSeconds(t2.claims.exp + i2), o3 > n2) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o3}) is after expiration time (${n2})`);
  if (null != t2.claims.nbf && K(t2.claims.nbf)) {
    const e3 = /* @__PURE__ */ new Date(0);
    if (e3.setUTCSeconds(t2.claims.nbf - i2), o3 < e3) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o3}) is before ${e3}`);
  }
  if (null != t2.claims.auth_time && K(t2.claims.auth_time)) {
    const n3 = /* @__PURE__ */ new Date(0);
    if (n3.setUTCSeconds(parseInt(t2.claims.auth_time) + e2.max_age + i2), o3 > n3) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o3}) is after last auth at ${n3}`);
  }
  if (e2.organization) {
    const i3 = e2.organization.trim();
    if (i3.startsWith("org_")) {
      const e3 = i3;
      if (!t2.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (e3 !== t2.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e3}", found "${t2.claims.org_id}"`);
    } else {
      const e3 = i3.toLowerCase();
      if (!t2.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (e3 !== t2.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e3}", found "${t2.claims.org_name}"`);
    }
  }
  return t2;
};
var R = o2(function(e2, i2) {
  var o3 = t && t.__assign || function() {
    return o3 = Object.assign || function(e3) {
      for (var t2, i3 = 1, o4 = arguments.length; i3 < o4; i3++) for (var n3 in t2 = arguments[i3]) Object.prototype.hasOwnProperty.call(t2, n3) && (e3[n3] = t2[n3]);
      return e3;
    }, o3.apply(this, arguments);
  };
  function n2(e3, t2) {
    if (!t2) return "";
    var i3 = "; " + e3;
    return true === t2 ? i3 : i3 + "=" + t2;
  }
  function a2(e3, t2, i3) {
    return encodeURIComponent(e3).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t2).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e4) {
      if ("number" == typeof e4.expires) {
        var t3 = /* @__PURE__ */ new Date();
        t3.setMilliseconds(t3.getMilliseconds() + 864e5 * e4.expires), e4.expires = t3;
      }
      return n2("Expires", e4.expires ? e4.expires.toUTCString() : "") + n2("Domain", e4.domain) + n2("Path", e4.path) + n2("Secure", e4.secure) + n2("SameSite", e4.sameSite);
    }(i3);
  }
  function r2(e3) {
    for (var t2 = {}, i3 = e3 ? e3.split("; ") : [], o4 = /(%[\dA-F]{2})+/gi, n3 = 0; n3 < i3.length; n3++) {
      var a3 = i3[n3].split("="), r3 = a3.slice(1).join("=");
      '"' === r3.charAt(0) && (r3 = r3.slice(1, -1));
      try {
        t2[a3[0].replace(o4, decodeURIComponent)] = r3.replace(o4, decodeURIComponent);
      } catch (e4) {
      }
    }
    return t2;
  }
  function s2() {
    return r2(document.cookie);
  }
  function c2(e3, t2, i3) {
    document.cookie = a2(e3, t2, o3({ path: "/" }, i3));
  }
  i2.__esModule = true, i2.encode = a2, i2.parse = r2, i2.getAll = s2, i2.get = function(e3) {
    return s2()[e3];
  }, i2.set = c2, i2.remove = function(e3, t2) {
    c2(e3, "", o3(o3({}, t2), { expires: -1 }));
  };
});
i(R), R.encode, R.parse, R.getAll;
var U = R.get, L = R.set, D = R.remove;
const X = { get(e2) {
  const t2 = U(e2);
  if (void 0 !== t2) return JSON.parse(t2);
}, save(e2, t2, i2) {
  let o3 = {};
  "https:" === window.location.protocol && (o3 = { secure: true, sameSite: "none" }), (null == i2 ? void 0 : i2.daysUntilExpire) && (o3.expires = i2.daysUntilExpire), (null == i2 ? void 0 : i2.cookieDomain) && (o3.domain = i2.cookieDomain), L(e2, JSON.stringify(t2), o3);
}, remove(e2, t2) {
  let i2 = {};
  (null == t2 ? void 0 : t2.cookieDomain) && (i2.domain = t2.cookieDomain), D(e2, i2);
} }, N = { get(e2) {
  const t2 = X.get(e2);
  return t2 || X.get(`_legacy_${e2}`);
}, save(e2, t2, i2) {
  let o3 = {};
  "https:" === window.location.protocol && (o3 = { secure: true }), (null == i2 ? void 0 : i2.daysUntilExpire) && (o3.expires = i2.daysUntilExpire), (null == i2 ? void 0 : i2.cookieDomain) && (o3.domain = i2.cookieDomain), L(`_legacy_${e2}`, JSON.stringify(t2), o3), X.save(e2, t2, i2);
}, remove(e2, t2) {
  let i2 = {};
  (null == t2 ? void 0 : t2.cookieDomain) && (i2.domain = t2.cookieDomain), D(e2, i2), X.remove(e2, t2), X.remove(`_legacy_${e2}`, t2);
} }, J = { get(e2) {
  if ("undefined" == typeof sessionStorage) return;
  const t2 = sessionStorage.getItem(e2);
  return null != t2 ? JSON.parse(t2) : void 0;
}, save(e2, t2) {
  sessionStorage.setItem(e2, JSON.stringify(t2));
}, remove(e2) {
  sessionStorage.removeItem(e2);
} };
function F(e2, t2, i2) {
  var o3 = void 0 === t2 ? null : t2, n2 = function(e3, t3) {
    var i3 = atob(e3);
    if (t3) {
      for (var o4 = new Uint8Array(i3.length), n3 = 0, a3 = i3.length; n3 < a3; ++n3) o4[n3] = i3.charCodeAt(n3);
      return String.fromCharCode.apply(null, new Uint16Array(o4.buffer));
    }
    return i3;
  }(e2, void 0 !== i2 && i2), a2 = n2.indexOf("\n", 10) + 1, r2 = n2.substring(a2) + (o3 ? "//# sourceMappingURL=" + o3 : ""), s2 = new Blob([r2], { type: "application/javascript" });
  return URL.createObjectURL(s2);
}
var H, Y, G, V, M = (H = "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", Y = null, G = false, function(e2) {
  return V = V || F(H, Y, G), new Worker(V, e2);
});
const A = {};
class B {
  constructor(e2, t2) {
    this.cache = e2, this.clientId = t2, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(e2) {
    var t2;
    const i2 = new Set((null === (t2 = await this.cache.get(this.manifestKey)) || void 0 === t2 ? void 0 : t2.keys) || []);
    i2.add(e2), await this.cache.set(this.manifestKey, { keys: [...i2] });
  }
  async remove(e2) {
    const t2 = await this.cache.get(this.manifestKey);
    if (t2) {
      const i2 = new Set(t2.keys);
      return i2.delete(e2), i2.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...i2] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(e2) {
    return `@@auth0spajs@@::${e2}`;
  }
}
const $ = { memory: () => new P().enclosedCache, localstorage: () => new z() }, q = (e2) => $[e2], Q = (t2) => {
  const { openUrl: i2, onRedirect: o3 } = t2, n2 = e(t2, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, n2), { openUrl: false === i2 || i2 ? i2 : o3 });
}, ee = new a();
class te {
  constructor(e2) {
    let t2, i2;
    if (this.userCache = new P().enclosedCache, this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: false, useFormData: true }, this._releaseLockOnPageHide = async () => {
      await ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
    }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e2), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e2.authorizationParams) }), "undefined" != typeof window && (() => {
      if (!w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (void 0 === w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
    })(), e2.cache && e2.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e2.cache) i2 = e2.cache;
    else {
      if (t2 = e2.cacheLocation || "memory", !q(t2)) throw new Error(`Invalid cache location "${t2}"`);
      i2 = q(t2)();
    }
    this.httpTimeoutMs = e2.httpTimeoutInSeconds ? 1e3 * e2.httpTimeoutInSeconds : 1e4, this.cookieStorage = false === e2.legacySameSiteCookie ? X : N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e3) => `auth0.${e3}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e2.sessionCheckExpiryDays || 1;
    const o3 = e2.useCookiesForTransactions ? this.cookieStorage : J;
    var n2;
    this.scope = j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new Z(o3, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || c, this.cacheManager = new x(i2, i2.allKeys ? void 0 : new B(i2, this.options.clientId), this.nowProvider), this.domainUrl = (n2 = this.options.domain, /^https?:\/\//.test(n2) ? n2 : `https://${n2}`), this.tokenIssuer = ((e3, t3) => e3 ? e3.startsWith("https://") ? e3 : `https://${e3}/` : `${t3}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t2 && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new M());
  }
  _url(e2) {
    const t2 = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || s)));
    return `${this.domainUrl}${e2}&auth0Client=${t2}`;
  }
  _authorizeUrl(e2) {
    return this._url(`/authorize?${v(e2)}`);
  }
  async _verifyIdToken(e2, t2, i2) {
    const o3 = await this.nowProvider();
    return E({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: e2, nonce: t2, organization: i2, leeway: this.options.leeway, max_age: (n2 = this.options.authorizationParams.max_age, "string" != typeof n2 ? n2 : parseInt(n2, 10) || void 0), now: o3 });
    var n2;
  }
  _processOrgHint(e2) {
    e2 ? this.cookieStorage.save(this.orgHintCookieName, e2, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(e2, t2, i2) {
    const o3 = k(y()), n2 = k(y()), a2 = y(), r2 = ((e3) => {
      const t3 = new Uint8Array(e3);
      return ((e4) => {
        const t4 = { "+": "-", "/": "_", "=": "" };
        return e4.replace(/[+/=]/g, (e5) => t4[e5]);
      })(window.btoa(String.fromCharCode(...Array.from(t3))));
    })(await (async (e3) => {
      const t3 = w().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(e3));
      return await t3;
    })(a2)), s2 = ((e3, t3, i3, o4, n3, a3, r3, s3) => Object.assign(Object.assign(Object.assign({ client_id: e3.clientId }, e3.authorizationParams), i3), { scope: j(t3, i3.scope), response_type: "code", response_mode: s3 || "query", state: o4, nonce: n3, redirect_uri: r3 || e3.authorizationParams.redirect_uri, code_challenge: a3, code_challenge_method: "S256" }))(this.options, this.scope, e2, o3, n2, r2, e2.redirect_uri || this.options.authorizationParams.redirect_uri || i2, null == t2 ? void 0 : t2.response_mode), c2 = this._authorizeUrl(s2);
    return { nonce: n2, code_verifier: a2, scope: s2.scope, audience: s2.audience || "default", redirect_uri: s2.redirect_uri, state: o3, url: c2 };
  }
  async loginWithPopup(e2, t2) {
    var i2;
    if (e2 = e2 || {}, !(t2 = t2 || {}).popup && (t2.popup = ((e3) => {
      const t3 = window.screenX + (window.innerWidth - 400) / 2, i3 = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(e3, "auth0:authorize:popup", `left=${t3},top=${i3},width=400,height=600,resizable,scrollbars=yes,status=1`);
    })(""), !t2.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
    const o3 = await this._prepareAuthorizeUrl(e2.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    t2.popup.location.href = o3.url;
    const n2 = await ((e3) => new Promise((t3, i3) => {
      let o4;
      const n3 = setInterval(() => {
        e3.popup && e3.popup.closed && (clearInterval(n3), clearTimeout(a3), window.removeEventListener("message", o4, false), i3(new p(e3.popup)));
      }, 1e3), a3 = setTimeout(() => {
        clearInterval(n3), i3(new h(e3.popup)), window.removeEventListener("message", o4, false);
      }, 1e3 * (e3.timeoutInSeconds || 60));
      o4 = function(r2) {
        if (r2.data && "authorization_response" === r2.data.type) {
          if (clearTimeout(a3), clearInterval(n3), window.removeEventListener("message", o4, false), e3.popup.close(), r2.data.response.error) return i3(d.fromPayload(r2.data.response));
          t3(r2.data.response);
        }
      }, window.addEventListener("message", o4);
    }))(Object.assign(Object.assign({}, t2), { timeoutInSeconds: t2.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (o3.state !== n2.state) throw new d("state_mismatch", "Invalid state");
    const a2 = (null === (i2 = e2.authorizationParams) || void 0 === i2 ? void 0 : i2.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: o3.audience, scope: o3.scope, code_verifier: o3.code_verifier, grant_type: "authorization_code", code: n2.code, redirect_uri: o3.redirect_uri }, { nonceIn: o3.nonce, organization: a2 });
  }
  async getUser() {
    var e2;
    const t2 = await this._getIdTokenFromCache();
    return null === (e2 = null == t2 ? void 0 : t2.decodedToken) || void 0 === e2 ? void 0 : e2.user;
  }
  async getIdTokenClaims() {
    var e2;
    const t2 = await this._getIdTokenFromCache();
    return null === (e2 = null == t2 ? void 0 : t2.decodedToken) || void 0 === e2 ? void 0 : e2.claims;
  }
  async loginWithRedirect(t2 = {}) {
    var i2;
    const o3 = Q(t2), { openUrl: n2, fragment: a2, appState: r2 } = o3, s2 = e(o3, ["openUrl", "fragment", "appState"]), c2 = (null === (i2 = s2.authorizationParams) || void 0 === i2 ? void 0 : i2.organization) || this.options.authorizationParams.organization, d2 = await this._prepareAuthorizeUrl(s2.authorizationParams || {}), { url: u2 } = d2, l2 = e(d2, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l2), { appState: r2 }), c2 && { organization: c2 }));
    const h2 = a2 ? `${u2}#${a2}` : u2;
    n2 ? await n2(h2) : window.location.assign(h2);
  }
  async handleRedirectCallback(e2 = window.location.href) {
    const t2 = e2.split("?").slice(1);
    if (0 === t2.length) throw new Error("There are no query params available for parsing.");
    const { state: i2, code: o3, error: n2, error_description: a2 } = ((e3) => {
      e3.indexOf("#") > -1 && (e3 = e3.substring(0, e3.indexOf("#")));
      const t3 = new URLSearchParams(e3);
      return { state: t3.get("state"), code: t3.get("code") || void 0, error: t3.get("error") || void 0, error_description: t3.get("error_description") || void 0 };
    })(t2.join("")), r2 = this.transactionManager.get();
    if (!r2) throw new d("missing_transaction", "Invalid state");
    if (this.transactionManager.remove(), n2) throw new u(n2, a2 || n2, i2, r2.appState);
    if (!r2.code_verifier || r2.state && r2.state !== i2) throw new d("state_mismatch", "Invalid state");
    const s2 = r2.organization, c2 = r2.nonce, l2 = r2.redirect_uri;
    return await this._requestToken(Object.assign({ audience: r2.audience, scope: r2.scope, code_verifier: r2.code_verifier, grant_type: "authorization_code", code: o3 }, l2 ? { redirect_uri: l2 } : {}), { nonceIn: c2, organization: s2 }), { appState: r2.appState };
  }
  async checkSession(e2) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated")) return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, true, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(e2);
    } catch (e3) {
    }
  }
  async getTokenSilently(e2 = {}) {
    var t2;
    const i2 = Object.assign(Object.assign({ cacheMode: "on" }, e2), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e2.authorizationParams), { scope: j(this.scope, null === (t2 = e2.authorizationParams) || void 0 === t2 ? void 0 : t2.scope) }) }), o3 = await ((e3, t3) => {
      let i3 = A[t3];
      return i3 || (i3 = e3().finally(() => {
        delete A[t3], i3 = null;
      }), A[t3] = i3), i3;
    })(() => this._getTokenSilently(i2), `${this.options.clientId}::${i2.authorizationParams.audience}::${i2.authorizationParams.scope}`);
    return e2.detailedResponse ? o3 : null == o3 ? void 0 : o3.access_token;
  }
  async _getTokenSilently(t2) {
    const { cacheMode: i2 } = t2, o3 = e(t2, ["cacheMode"]);
    if ("off" !== i2) {
      const e2 = await this._getEntryFromCache({ scope: o3.authorizationParams.scope, audience: o3.authorizationParams.audience || "default", clientId: this.options.clientId });
      if (e2) return e2;
    }
    if ("cache-only" !== i2) {
      if (!await (async (e2, t3 = 3) => {
        for (let i3 = 0; i3 < t3; i3++) if (await e2()) return true;
        return false;
      })(() => ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new l();
      try {
        if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i2) {
          const e3 = await this._getEntryFromCache({ scope: o3.authorizationParams.scope, audience: o3.authorizationParams.audience || "default", clientId: this.options.clientId });
          if (e3) return e3;
        }
        const e2 = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o3) : await this._getTokenFromIFrame(o3), { id_token: t3, access_token: n2, oauthTokenScope: a2, expires_in: r2 } = e2;
        return Object.assign(Object.assign({ id_token: t3, access_token: n2 }, a2 ? { scope: a2 } : null), { expires_in: r2 });
      } finally {
        await ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
      }
    }
  }
  async getTokenWithPopup(e2 = {}, t2 = {}) {
    var i2;
    const o3 = Object.assign(Object.assign({}, e2), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e2.authorizationParams), { scope: j(this.scope, null === (i2 = e2.authorizationParams) || void 0 === i2 ? void 0 : i2.scope) }) });
    t2 = Object.assign(Object.assign({}, r), t2), await this.loginWithPopup(o3, t2);
    return (await this.cacheManager.get(new C({ scope: o3.authorizationParams.scope, audience: o3.authorizationParams.audience || "default", clientId: this.options.clientId }))).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(t2) {
    null !== t2.clientId ? t2.clientId = t2.clientId || this.options.clientId : delete t2.clientId;
    const i2 = t2.logoutParams || {}, { federated: o3 } = i2, n2 = e(i2, ["federated"]), a2 = o3 ? "&federated" : "";
    return this._url(`/v2/logout?${v(Object.assign({ clientId: t2.clientId }, n2))}`) + a2;
  }
  async logout(t2 = {}) {
    const i2 = Q(t2), { openUrl: o3 } = i2, n2 = e(i2, ["openUrl"]);
    null === t2.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t2.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@");
    const a2 = this._buildLogoutUrl(n2);
    o3 ? await o3(a2) : false !== o3 && window.location.assign(a2);
  }
  async _getTokenFromIFrame(e2) {
    const t2 = Object.assign(Object.assign({}, e2.authorizationParams), { prompt: "none" }), i2 = this.cookieStorage.get(this.orgHintCookieName);
    i2 && !t2.organization && (t2.organization = i2);
    const { url: o3, state: n2, nonce: a2, code_verifier: r2, redirect_uri: s2, scope: c2, audience: u2 } = await this._prepareAuthorizeUrl(t2, { response_mode: "web_message" }, window.location.origin);
    try {
      if (window.crossOriginIsolated) throw new d("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
      const i3 = e2.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h2 = await ((e3, t3, i4 = 60) => new Promise((o4, n3) => {
        const a3 = window.document.createElement("iframe");
        a3.setAttribute("width", "0"), a3.setAttribute("height", "0"), a3.style.display = "none";
        const r3 = () => {
          window.document.body.contains(a3) && (window.document.body.removeChild(a3), window.removeEventListener("message", s3, false));
        };
        let s3;
        const c3 = setTimeout(() => {
          n3(new l()), r3();
        }, 1e3 * i4);
        s3 = function(e4) {
          if (e4.origin != t3) return;
          if (!e4.data || "authorization_response" !== e4.data.type) return;
          const i5 = e4.source;
          i5 && i5.close(), e4.data.response.error ? n3(d.fromPayload(e4.data.response)) : o4(e4.data.response), clearTimeout(c3), window.removeEventListener("message", s3, false), setTimeout(r3, 2e3);
        }, window.addEventListener("message", s3, false), window.document.body.appendChild(a3), a3.setAttribute("src", e3);
      }))(o3, this.domainUrl, i3);
      if (n2 !== h2.state) throw new d("state_mismatch", "Invalid state");
      const p2 = await this._requestToken(Object.assign(Object.assign({}, e2.authorizationParams), { code_verifier: r2, code: h2.code, grant_type: "authorization_code", redirect_uri: s2, timeout: e2.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: a2, organization: t2.organization });
      return Object.assign(Object.assign({}, p2), { scope: c2, oauthTokenScope: p2.scope, audience: u2 });
    } catch (e3) {
      throw "login_required" === e3.error && this.logout({ openUrl: false }), e3;
    }
  }
  async _getTokenUsingRefreshToken(e2) {
    const t2 = await this.cacheManager.get(new C({ scope: e2.authorizationParams.scope, audience: e2.authorizationParams.audience || "default", clientId: this.options.clientId }));
    if (!(t2 && t2.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e2);
      throw new f(e2.authorizationParams.audience || "default", e2.authorizationParams.scope);
    }
    const i2 = e2.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o3 = "number" == typeof e2.timeoutInSeconds ? 1e3 * e2.timeoutInSeconds : null;
    try {
      const n2 = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e2.authorizationParams), { grant_type: "refresh_token", refresh_token: t2 && t2.refresh_token, redirect_uri: i2 }), o3 && { timeout: o3 }));
      return Object.assign(Object.assign({}, n2), { scope: e2.authorizationParams.scope, oauthTokenScope: n2.scope, audience: e2.authorizationParams.audience || "default" });
    } catch (t3) {
      if ((t3.message.indexOf("Missing Refresh Token") > -1 || t3.message && t3.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e2);
      throw t3;
    }
  }
  async _saveEntryInCache(t2) {
    const { id_token: i2, decodedToken: o3 } = t2, n2 = e(t2, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: i2, decodedToken: o3 }), await this.cacheManager.setIdToken(this.options.clientId, t2.id_token, t2.decodedToken), await this.cacheManager.set(n2);
  }
  async _getIdTokenFromCache() {
    const e2 = this.options.authorizationParams.audience || "default", t2 = await this.cacheManager.getIdToken(new C({ clientId: this.options.clientId, audience: e2, scope: this.scope })), i2 = this.userCache.get("@@user@@");
    return t2 && t2.id_token === (null == i2 ? void 0 : i2.id_token) ? i2 : (this.userCache.set("@@user@@", t2), t2);
  }
  async _getEntryFromCache({ scope: e2, audience: t2, clientId: i2 }) {
    const o3 = await this.cacheManager.get(new C({ scope: e2, audience: t2, clientId: i2 }), 60);
    if (o3 && o3.access_token) {
      const { access_token: e3, oauthTokenScope: t3, expires_in: i3 } = o3, n2 = await this._getIdTokenFromCache();
      return n2 && Object.assign(Object.assign({ id_token: n2.id_token, access_token: e3 }, t3 ? { scope: t3 } : null), { expires_in: i3 });
    }
  }
  async _requestToken(e2, t2) {
    const { nonceIn: i2, organization: o3 } = t2 || {}, n2 = await T(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs }, e2), this.worker), a2 = await this._verifyIdToken(n2.id_token, i2, o3);
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n2), { decodedToken: a2, scope: e2.scope, audience: e2.audience || "default" }), n2.scope ? { oauthTokenScope: n2.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, true, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(o3 || a2.claims.org_id), Object.assign(Object.assign({}, n2), { decodedToken: a2 });
  }
}
async function oe(e2) {
  const t2 = new te(e2);
  return await t2.checkSession(), t2;
}
const version = "1.16.2";
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var Symbol$1 = root.Symbol;
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var nativeObjectToString$1 = objectProto$9.toString;
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$7.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$8 = Object.prototype;
var nativeObjectToString = objectProto$8.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isArray = Array.isArray;
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
function identity(value) {
  return value;
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$7 = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$6).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ function() {
  function object() {
  }
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
}();
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function copyArray(source, array) {
  var index = -1, length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
function constant(value) {
  return function() {
    return value;
  };
}
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e2) {
  }
}();
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
var setToString = shortOut(baseSetToString);
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
function baseAssignValue(object, key, value) {
  if (key == "__proto__" && defineProperty) {
    defineProperty(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1, length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}
var nativeMax = Math.max;
function overRest(func, start, transform) {
  start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
    return eq(object[index], value);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? void 0 : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}
var objectProto$5 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$5;
  return value === proto;
}
function baseTimes(n2, iteratee) {
  var index = -1, result = Array(n2);
  while (++index < n2) {
    result[index] = iteratee(index);
  }
  return result;
}
var argsTag$1 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$1;
}
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
var propertyIsEnumerable = objectProto$4.propertyIsEnumerable;
var isArguments = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root.Buffer : void 0;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag$1 = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = function() {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e2) {
  }
}();
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if (!(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? void 0 : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : void 0;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty$1.call(data, key);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root, "Map");
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var getPrototype = overArg(Object.getPrototypeOf, Object);
var objectTag = "[object Object]";
var funcProto = Function.prototype, objectProto = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty = objectProto.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer2 = moduleExports ? root.Buffer : void 0;
Buffer2 ? Buffer2.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  {
    return buffer.slice();
  }
}
var Uint8Array$1 = root.Uint8Array;
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer = cloneArrayBuffer(typedArray.buffer);
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
function initCloneObject(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
    while (length--) {
      var key = props[++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var baseFor = createBaseFor();
function assignMergeValue(object, key, value) {
  if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}
function safeGet(object, key) {
  if (key === "constructor" && typeof object[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object[key];
}
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue(object, key, newValue);
}
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack());
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
let logger;
const setLogger = (l2) => {
  logger = l2;
};
const canUseDOM = () => {
  var _a;
  return !!(typeof window !== "undefined" && ((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.createElement));
};
const mergeObjects = (first, second) => {
  return merge(first, second);
};
const canUseLocalStorage = () => {
  if (typeof window === "undefined") {
    if (logger) {
      logger.warnWithContext(
        "utils",
        "canUseLocalStorage: window is undefined"
      );
    }
    return false;
  }
  try {
    localStorage.setItem("test", "test");
    localStorage.removeItem("test");
    return true;
  } catch (e2) {
    if (logger) {
      logger.errorWithContext(
        "utils",
        "canUseLocalStorage: localStorage is not available",
        e2
      );
    }
    return false;
  }
};
const canUseSessionStorage = () => {
  if (typeof window === "undefined") {
    if (logger) {
      logger.warnWithContext(
        "utils",
        "canUseSessionStorage: window is undefined"
      );
    }
    return false;
  }
  try {
    sessionStorage.setItem("test", "test");
    sessionStorage.removeItem("test");
    return true;
  } catch (e2) {
    if (logger) {
      logger.errorWithContext(
        "utils",
        "canUseSessionStorage: sessionStorage is not available",
        e2
      );
    }
    return false;
  }
};
const setEvtSrc = (source) => {
  canUseSessionStorage() && safeSetStorageItem(sessionStorage, "evtSrc", source);
};
const oldSessionCheck = () => {
  if (canUseLocalStorage() && safeGetStorageItem(localStorage, "ALMA")) {
    safeSetStorageItem(sessionStorage, "sessionMigration", "true");
    safeRemoveStorageItem(localStorage, "ALMA");
    return true;
  }
  return false;
};
const sessionRefreshCheck = () => {
  const lastRefresh = safeGetStorageItem(localStorage, "lastSessionRefresh");
  const today = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
  if (!lastRefresh) {
    safeSetStorageItem(localStorage, "lastSessionRefresh", today);
  }
  const lastRefreshDate = new Date(lastRefresh ?? today).setHours(0, 0, 0, 0);
  const todayDate = new Date(today).setHours(0, 0, 0, 0);
  const refreshNeeded = lastRefreshDate < todayDate;
  if (refreshNeeded) {
    safeSetStorageItem(localStorage, "lastSessionRefresh", today);
  }
  return refreshNeeded;
};
const isDevDomain = (domain) => {
  return domain.includes("tunnus-dev") || domain.includes("development");
};
const getSelfServiceAPIUrlWithDomain = (domain) => {
  const url = new URL(
    isDevDomain(domain) ? "https://itsepalvelu-api.tunnus-dev.almamedia.net/v1/self-service" : "https://itsepalvelu-api.tunnus.almamedia.io/v1/self-service"
  );
  return url.toString();
};
const getVerifyEmailParams = (clientID, user_id, additionalParams) => {
  const clientIdParam = new URLSearchParams({
    clientId: clientID,
    id: user_id,
    response_type: "json"
  });
  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (key.match(/^client[-_]?id$/i)) {
        continue;
      }
      if (key.match(/user[-_]?id/i)) {
        continue;
      }
      if (key.match(/^id$/i)) {
        continue;
      }
      let paramValue = value;
      if (typeof paramValue === "object") {
        paramValue = JSON.stringify(paramValue);
      }
      clientIdParam.append(key, paramValue);
    }
  }
  return clientIdParam.toString();
};
const getPasswordChangeParams = (clientId, additionalParams) => {
  const clientIdParam = new URLSearchParams({
    clientId
  });
  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (key.match(/^client[-_]?id$/i)) {
        continue;
      }
      let paramValue = value;
      if (typeof paramValue === "object") {
        paramValue = JSON.stringify(paramValue);
      }
      clientIdParam.append(key, paramValue);
    }
  }
  return clientIdParam.toString();
};
const openPopup = () => {
  if (canUseDOM()) {
    try {
      const height = Math.min(window.screen.height, 980);
      const centered = `left=${window.screen.width / 2 - 480 / 2},top=${window.screen.height / 2 - height / 2 - 50}`;
      const styles = `scrollbars=true,innerWidth=480px,height=${height},toolbar=no,location=no,menubar=no,status=no,resizable=yes,${centered}`;
      const popup = window.open("", "popupWindow", styles);
      if (!popup || popup.closed || typeof popup.closed === "undefined") {
        if (logger) {
          logger.warnWithContext(
            "utils",
            "Popup window was blocked by the browser"
          );
        }
      }
      return popup;
    } catch (error) {
      if (logger) {
        logger.errorWithContext("utils", "Failed to open popup window:", error);
      }
      return null;
    }
  }
  return null;
};
const safeGetStorageItem = (storage, key) => {
  try {
    return storage.getItem(key);
  } catch (error) {
    if (logger) {
      logger.errorWithContext(
        "utils",
        `Error getting ${key} from storage:`,
        error
      );
    }
    return null;
  }
};
const safeSetStorageItem = (storage, key, value) => {
  try {
    storage.setItem(key, value);
    return true;
  } catch (error) {
    if (logger) {
      logger.errorWithContext(
        "utils",
        `Error setting ${key} in storage:`,
        error
      );
    }
    return false;
  }
};
const safeRemoveStorageItem = (storage, key) => {
  try {
    storage.removeItem(key);
    return true;
  } catch (error) {
    if (logger) {
      logger.errorWithContext(
        "utils",
        `Error removing ${key} from storage:`,
        error
      );
    }
    return false;
  }
};
const hasAuthParams = () => {
  if (!canUseDOM()) return false;
  const query = window.location.search;
  return query.includes("code=") && query.includes("state=");
};
const filterUndefined = (obj) => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (value === void 0) return acc;
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const filtered = filterUndefined(value);
        if (Object.keys(filtered).length > 0) {
          acc[key] = filtered;
        }
        return acc;
      }
      acc[key] = value;
      return acc;
    },
    {}
  );
};
const cleanupIframe = (iframe, messageHandler) => {
  if (iframe == null ? void 0 : iframe.parentNode) {
    if (messageHandler) {
      window.removeEventListener("message", messageHandler);
    }
    iframe.parentNode.removeChild(iframe);
  }
};
const checkActiveSession = async ({
  domain,
  timeout = 1500
}) => {
  if (!canUseDOM()) {
    return false;
  }
  return new Promise((resolve) => {
    const iframe = document.createElement("iframe");
    let isResolved = false;
    const messageHandler = (event) => {
      if (isResolved) {
        return;
      }
      const trustedOrigin = `https://assets.${domain}`;
      if (event.origin !== trustedOrigin) {
        if (logger) {
          logger.warnWithContext(
            "utils",
            `Unauthorized origin: ${event.origin}`
          );
        }
        return;
      }
      if (event.data === "at-session-active") {
        isResolved = true;
        clearTimeout(timeoutId);
        cleanupIframe(iframe, messageHandler);
        resolve(true);
      } else if (event.data === "at-session-inactive") {
        isResolved = true;
        clearTimeout(timeoutId);
        cleanupIframe(iframe, messageHandler);
        resolve(false);
      }
    };
    const timeoutId = setTimeout(() => {
      if (!isResolved) {
        if (logger) {
          logger.warnWithContext("utils", "Session/cookie check timed out");
        }
        isResolved = true;
        cleanupIframe(iframe, messageHandler);
        resolve(false);
      }
    }, timeout);
    window.addEventListener("message", messageHandler);
    iframe.style.display = "none";
    iframe.src = `https://assets.${domain}/cookies/sessionCheck.html`;
    document.body.appendChild(iframe);
    iframe.onerror = () => {
      if (!isResolved) {
        if (logger) {
          logger.warnWithContext("utils", "Iframe failed to load");
        }
        isResolved = true;
        clearTimeout(timeoutId);
        cleanupIframe(iframe, messageHandler);
        resolve(false);
      }
    };
  });
};
const setSessionActive = async ({
  domain,
  clientId,
  timeout = 2e3
}) => {
  if (!canUseDOM()) {
    return;
  }
  try {
    if (logger) {
      logger.infoWithContext("utils", "Setting session active");
    }
    const iframe = document.createElement("iframe");
    const messageHandler = (event) => {
      if (event.data === "at-session-active") {
        if (logger) {
          logger.infoWithContext("utils", "Session active set");
        }
        clearTimeout(timeoutId);
        cleanupIframe(iframe, messageHandler);
      }
    };
    const timeoutId = setTimeout(() => {
      cleanupIframe(iframe, messageHandler);
    }, timeout);
    window.addEventListener("message", messageHandler);
    iframe.style.display = "none";
    const baseUrl = `https://assets.${domain}/cookies/sessionCheck.html`;
    const url = `${baseUrl}?client_id=${encodeURIComponent(clientId)}#set`;
    iframe.src = url;
    document.body.appendChild(iframe);
  } catch (error) {
    if (logger) {
      logger.errorWithContext("utils", "Failed to set session active:", error);
    }
  }
};
const removeSessionData = async (domain) => {
  if (!canUseDOM()) {
    return;
  }
  if (logger) {
    logger.infoWithContext("utils", "Removing session data");
  }
  const baseUrl = `https://assets.${domain}/cookies/sessionCheck.html`;
  const url = `${baseUrl}#remove`;
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = url;
  document.body.appendChild(iframe);
};
var Severity;
(function(Severity2) {
  Severity2["fatal"] = "fatal";
  Severity2["error"] = "error";
  Severity2["warning"] = "warning";
  Severity2["log"] = "log";
  Severity2["info"] = "info";
  Severity2["debug"] = "debug";
  Severity2["critical"] = "critical";
})(Severity || (Severity = {}));
const CHROME_REGEXP = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const GECKO_REGEXP = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
const WINJS_REGEXP = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const UNKNOWN_FUNCTION = "?";
const AUTH_HEADER = "X-Sentry-Auth";
const DSN_REGEXP = (
  //|protocol     |public    |secret      |host    |port       |projectId
  //|
  /^(?:(\w+):)\/\/(?:([\w-]+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/
);
function computeStackTraceFromStackProp(ex) {
  if (!ex.stack) {
    return null;
  }
  const stack = [];
  const lines = ex.stack.split("\n");
  let parts;
  let element;
  for (let i2 = 0; i2 < lines.length; ++i2) {
    if (parts = CHROME_REGEXP.exec(lines[i2])) {
      element = {
        // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
        // prefix here seems like the quickest solution for now.
        filename: parts[2] && parts[2].indexOf("address at ") === 0 ? parts[2].substr("address at ".length) : parts[2],
        function: parts[1] || UNKNOWN_FUNCTION,
        lineno: parts[3] ? +parts[3] : null,
        colno: parts[4] ? +parts[4] : null
      };
    } else if (parts = WINJS_REGEXP.exec(lines[i2])) {
      element = {
        filename: parts[2],
        function: parts[1] || UNKNOWN_FUNCTION,
        lineno: +parts[3],
        colno: parts[4] ? +parts[4] : null
      };
    } else if (parts = GECKO_REGEXP.exec(lines[i2])) {
      if (i2 === 0 && !parts[5] && ex.columnNumber !== void 0) {
        stack[0].column = ex.columnNumber + 1;
      }
      element = {
        filename: parts[3],
        function: parts[1] || UNKNOWN_FUNCTION,
        lineno: parts[4] ? +parts[4] : null,
        colno: parts[5] ? +parts[5] : null
      };
    } else {
      continue;
    }
    if (!element.function && element.lineno) {
      element.function = UNKNOWN_FUNCTION;
    }
    stack.push(element);
  }
  if (!stack.length) {
    return null;
  }
  return {
    value: extractMessage(ex),
    type: ex.name,
    stacktrace: { frames: stack.reverse() }
  };
}
function extractMessage(ex) {
  const message = ex && ex.message || "No error message";
  return message.split("\n").filter((s2) => !!s2)[0];
}
function computeStackTrace(ex) {
  try {
    const stack = computeStackTraceFromStackProp(ex);
    if (stack) {
      return stack;
    }
  } catch (e2) {
  }
  return {
    value: extractMessage(ex),
    type: ex && ex.name,
    stacktrace: { frames: [] }
  };
}
function uuid4() {
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, (c2) => {
    const r2 = Math.random() * 16 | 0;
    const v2 = c2 === "x" ? r2 : r2 & 3 | 8;
    return v2.toString(16);
  });
}
class MicroSentryClient {
  constructor(options) {
    if (options && options.dsn) {
      const searched = DSN_REGEXP.exec(options.dsn);
      const dsn = searched ? searched.slice(1) : [];
      const pathWithProjectId = dsn[5].split("/");
      const path = pathWithProjectId.slice(0, -1).join("/");
      this.apiUrl = dsn[0] + "://" + dsn[3] + (dsn[4] ? ":" + dsn[4] : "") + (path ? "/" + path : "") + "/api/" + pathWithProjectId.pop() + "/store/";
      this.authHeader = "Sentry sentry_version=7,sentry_key=" + dsn[1] + (dsn[2] ? ",sentry_secret=" + dsn[2] : "");
    }
    this.environment = options && options.environment;
  }
  prepare(error) {
    return {
      ...this.getRequestBlank(),
      exception: { values: [computeStackTrace(error)] }
    };
  }
  report(error) {
    this.send(this.prepare(error));
  }
  send(body) {
    if (!this.apiUrl || !body) {
      return;
    }
    this.createRequest(body);
  }
  createRequest(body) {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", this.apiUrl, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader(AUTH_HEADER, this.authHeader || "");
    xhr.send(JSON.stringify(body));
  }
  getRequestBlank() {
    return {
      platform: "javascript",
      event_id: uuid4(),
      sdk: {
        name: "micro-sentry.javascript.core",
        version: "0.0.0"
      },
      timestamp: Date.now() / 1e3,
      environment: this.environment
    };
  }
}
function isMatchingPattern(value, pattern) {
  if (Object.prototype.toString.call(pattern) === "[object RegExp]") {
    return pattern.test(value);
  }
  if (typeof pattern === "string") {
    return value.indexOf(pattern) !== -1;
  }
  return false;
}
const MAX_BREADCRUMBS = 100;
function getWindow() {
  return window;
}
class BrowserMicroSentryClient extends MicroSentryClient {
  constructor(options, window2 = getWindow()) {
    super(options);
    this.options = options;
    this.window = window2;
    this.breadcrumbsKeyName = "breadcrumbs";
    this.destroyed = false;
    this._state = {};
    const { plugins = [], beforeSend = (req) => req, beforeBreadcrumb = (breadcrumb) => breadcrumb, blacklistUrls = [], ignoreErrors = [], release = void 0, maxBreadcrumbs = MAX_BREADCRUMBS } = this.options || {};
    this.plugins = plugins.map((Plugin) => new Plugin(this));
    this.beforeSend = beforeSend;
    this.beforeBreadcrumb = beforeBreadcrumb;
    this.blacklistUrls = blacklistUrls;
    this.ignoreErrors = ignoreErrors;
    this.release = release;
    this.maxBreadcrumbs = maxBreadcrumbs >= 0 ? maxBreadcrumbs : MAX_BREADCRUMBS;
  }
  get state() {
    return this._state;
  }
  clearState() {
    this._state = {};
  }
  setTags(tags) {
    this.setKeyState("tags", { ...tags });
    return this;
  }
  setTag(key, value) {
    this.extendState({ tags: { [key]: value } });
    return this;
  }
  setExtra(key, value) {
    this.extendState({ extra: { [key]: value } });
    return this;
  }
  setExtras(extras) {
    this.setKeyState("extra", { ...extras });
    return this;
  }
  setUser(user) {
    this.setKeyState("user", user ? { ...user } : void 0);
    return this;
  }
  clone() {
    const client = new BrowserMicroSentryClient({
      ...this.options,
      plugins: []
    });
    client.extendState(this.state);
    return client;
  }
  withScope(fn) {
    const clone = this.clone();
    fn(clone);
    clone.destroy();
    this.setBreadcrumbs(void 0);
  }
  addBreadcrumb(breadcrumb) {
    const result = this.beforeBreadcrumb(breadcrumb);
    if (!result) {
      return;
    }
    this.extendState({
      [this.breadcrumbsKeyName]: [
        {
          timestamp: Date.now() / 1e3,
          ...result
        }
      ]
    });
    this.trimBreadcrumbs();
  }
  setBreadcrumbs(breadcrumbs) {
    this.setKeyState(this.breadcrumbsKeyName, breadcrumbs);
    this.trimBreadcrumbs();
  }
  captureMessage(message, level) {
    this.send({
      ...this.getRequestBlank(),
      message,
      level
    });
  }
  destroy() {
    this.destroyed = true;
    this.plugins.forEach((plugin) => {
      if (plugin.destroy) {
        plugin.destroy();
      }
    });
  }
  isIgnoredError(event) {
    if (!this.ignoreErrors.length) {
      return false;
    }
    return this.getPossibleEventMessages(event).some((message) => this.ignoreErrors.some((pattern) => isMatchingPattern(message, pattern)));
  }
  extractQueryString(originalUrl) {
    let url = originalUrl;
    if (!url) {
      return void 0;
    }
    if (url.startsWith("/")) {
      url = `http://prefix${url}`;
    }
    try {
      const queryString = new URL(url).search.slice(1);
      return queryString.length ? queryString : void 0;
    } catch (e2) {
      return void 0;
    }
  }
  getRequestBlank() {
    const url = this.window.location.toString();
    return {
      request: {
        url,
        query_string: this.extractQueryString(url),
        headers: {
          "User-Agent": this.window.navigator.userAgent
        }
      },
      ...super.getRequestBlank(),
      sdk: {
        name: "micro-sentry.javascript.browser",
        version: "0.0.0"
      },
      ...this.state
    };
  }
  send(request) {
    if (this.destroyed || this.isDeniedUrl(request) || this.isIgnoredError(request)) {
      return;
    }
    const beforeSendResult = this.beforeSend({
      release: this.release,
      ...request
    });
    if (!beforeSendResult) {
      return;
    }
    super.send(beforeSendResult);
    this.setBreadcrumbs(void 0);
  }
  getPossibleEventMessages(event) {
    if (event.message) {
      return [event.message];
    }
    if (event.exception) {
      try {
        const { type = "", value = "" } = event.exception.values && event.exception.values[0] || {};
        return [`${value}`, `${type}: ${value}`];
      } catch (e2) {
        return [];
      }
    }
    return [];
  }
  isDeniedUrl(event) {
    if (!this.blacklistUrls.length) {
      return false;
    }
    const url = this.getEventFilterUrl(event);
    return !url ? false : this.blacklistUrls.some((pattern) => isMatchingPattern(url, pattern));
  }
  getEventFilterUrl(event) {
    try {
      if (event.exception) {
        const frames = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
        return frames && frames[frames.length - 1].filename || null;
      }
      return null;
    } catch (e2) {
      return null;
    }
  }
  extendState(newState) {
    this._state = Object.keys(newState).reduce((acc, key) => {
      const stateValue = this._state[key];
      const stateArray = Array.isArray(stateValue) ? stateValue : null;
      const newStateValue = newState[key];
      const newStateArray = Array.isArray(newStateValue) ? newStateValue : null;
      return {
        ...acc,
        [key]: stateArray || newStateArray ? [...stateArray || [], ...newStateArray || []] : {
          ...typeof stateValue !== "string" ? stateValue : {},
          ...typeof newStateValue !== "string" ? newStateValue : {}
        }
      };
    }, this._state);
  }
  setKeyState(key, value) {
    this._state[key] = value;
  }
  getKeyState(key) {
    return this._state[key];
  }
  trimBreadcrumbs() {
    const breadcrumbs = this.getKeyState(this.breadcrumbsKeyName);
    if (breadcrumbs && (breadcrumbs.length ?? 0) > this.maxBreadcrumbs) {
      this.setKeyState(this.breadcrumbsKeyName, this.maxBreadcrumbs > 0 ? breadcrumbs.slice(-this.maxBreadcrumbs) : []);
    }
  }
}
const _AlmaAccountCore = class _AlmaAccountCore {
  /**
   * Private constructor for AlmaAccountCore singleton class
   * This constructor is private because this class is a singleton.
   * @private
   */
  constructor() {
    /** Logger instance for the AlmaAccountCore class */
    __publicField(this, "logger");
    __publicField(this, "consoleFunctions");
    /** Internal Auth0 client instance */
    __publicField(this, "_auth0Instance", null);
    __publicField(this, "_coreConfig");
    __publicField(this, "_cmpHandler");
    __publicField(this, "_sentryInstance");
    __publicField(this, "_sentryDisabled");
    __publicField(this, "_production", true);
    __publicField(this, "_cmp", {
      // CMP values are always true; see note below
      standard: false,
      ga: false,
      facebook: false,
      google: false,
      apple: false,
      linkedin: false
    });
    /** Function to print the current configuration to the console */
    __publicField(this, "printConfig");
    /** Function to print the version information to the console */
    __publicField(this, "printVersionInfo");
    /**
     * Checks if the AlmaAccountCore instance has been initialized
     * @returns {boolean} True if the Auth0 instance is initialized, false otherwise
     */
    __publicField(this, "isInitialized", () => this._auth0Instance !== null);
    /**
     * Initializes the Auth0 client with provided configuration
     * Sets up storage handling and authentication parameters
     * @param config - Configuration object for Auth0 and core functionality
     * @returns {Promise<void>}
     * @throws Error if initialization fails
     */
    __publicField(this, "init", async (config) => {
      var _a, _b, _c, _d;
      try {
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("init", "with config", config);
        this._coreConfig = config;
        this._mapConsoleFunctionsToWindow();
        const localStorageAvailable = canUseLocalStorage();
        const sessionStorageAvailable = canUseSessionStorage();
        const cacheLocation = (config == null ? void 0 : config.cacheLocation) ?? (localStorageAvailable ? "localstorage" : "memory");
        if (!this._auth0Instance) {
          if (!(config == null ? void 0 : config.domain)) {
            throw new Error("Domain is required for Auth0 initialization");
          }
          const options = filterUndefined({
            clientId: config == null ? void 0 : config.clientID,
            domain: config.domain,
            useRefreshTokens: ((_b = config == null ? void 0 : config.scope) == null ? void 0 : _b.includes("offline_access")) ?? false,
            // if localStorageAvailable is false, cacheLocation is set to memory, otherwise it can be set to localstorage if `cacheLocation` sets it to localstorage
            cacheLocation: localStorageAvailable ? cacheLocation : "memory",
            useRefreshTokensFallback: true,
            cookieDomain: config == null ? void 0 : config.cookieDomain,
            useCookiesForTransactions: (!sessionStorageAvailable || (config == null ? void 0 : config.useCookiesForTransactions)) ?? false,
            legacySameSiteCookie: (config == null ? void 0 : config.legacySameSiteCookie) ?? false,
            sessionCheckExpiryDays: (config == null ? void 0 : config.sessionCheckExpiryDays) ?? 365,
            useFormData: false,
            authorizationParams: {
              scope: config == null ? void 0 : config.scope,
              audience: config == null ? void 0 : config.audience,
              redirect_uri: config == null ? void 0 : config.redirectUri,
              connection: (config == null ? void 0 : config.connection) || (config == null ? void 0 : config.realm),
              // TODO: remove realm once it's not required anymore in universal
              realm: (config == null ? void 0 : config.connection) || (config == null ? void 0 : config.realm)
            }
          });
          this._auth0Instance = await oe(options).then((res) => {
            var _a2;
            (_a2 = this.logger) == null ? void 0 : _a2.infoWithContext("auth0Instance initialized: ", res);
            return res;
          });
        } else {
          (_c = this.logger) == null ? void 0 : _c.warnWithContext(
            "init",
            "auth0Instance already initialized, is init called more than once?"
          );
        }
        return Promise.resolve();
      } catch (error) {
        (_d = this.logger) == null ? void 0 : _d.errorWithContext("init", error.message, error);
        this.reportToSentry("init", error);
        throw error;
      }
    });
    /**
     * Handles authentication via popup window
     * Manages CMP consent collection before authentication
     * @param loginOptions - Options for the login process
     * @param popupOptions - Configuration for the popup window
     * @returns {Promise<void>}
     */
    __publicField(this, "popupLogin", async (loginOptions, popupOptions) => {
      var _a, _b, _c, _d, _e, _f, _g;
      try {
        this.checkInitialization();
        const cmp = _AlmaAccountCore._cmpHandlerEnabled ? await ((_a = this._cmpHandler) == null ? void 0 : _a.getConsents({ timeout: 700 })) ?? this._cmp : {
          ...this._cmp,
          ...((_b = loginOptions == null ? void 0 : loginOptions.authorizationParams) == null ? void 0 : _b.cmp) ?? {}
        };
        (_c = loginOptions == null ? void 0 : loginOptions.authorizationParams) == null ? true : delete _c.cmp;
        (_d = this.logger) == null ? void 0 : _d.infoWithContext("popupLogin");
        if ((_e = loginOptions == null ? void 0 : loginOptions.authorizationParams) == null ? void 0 : _e.source) {
          setEvtSrc(loginOptions.authorizationParams.source);
        }
        const mergeOptions = popupOptions || {};
        if (!(mergeOptions == null ? void 0 : mergeOptions.popup)) {
          mergeOptions.popup = openPopup();
        }
        const options = mergeObjects(
          {
            authorizationParams: {
              response_type: "code",
              response_mode: "web_message",
              redirect_uri: this._coreConfig.redirectUri,
              cmp: JSON.stringify(cmp),
              universal: "v3",
              connection: this._coreConfig.connection || this._coreConfig.realm,
              realm: this._coreConfig.connection || this._coreConfig.realm
            }
          },
          loginOptions
        );
        await ((_f = this._auth0Instance) == null ? void 0 : _f.loginWithPopup(options, {
          timeoutInSeconds: 1200,
          ...mergeOptions
        }));
        await setSessionActive({
          domain: this._coreConfig.domain,
          clientId: this._coreConfig.clientID
        });
      } catch (error) {
        (_g = this.logger) == null ? void 0 : _g.errorWithContext("popupLogin", error.message, error);
        if (error.error !== "Error: Popup closed") {
          this.reportToSentry("popupLogin", error);
        }
      }
    });
    /**
     * Handles authentication via redirect flow
     * Collects CMP consents before redirecting
     * @param loginOptions - Options for the login process
     */
    __publicField(this, "login", async (loginOptions) => {
      var _a, _b, _c, _d, _e, _f;
      try {
        this.checkInitialization();
        const cmp = _AlmaAccountCore._cmpHandlerEnabled ? await ((_a = this._cmpHandler) == null ? void 0 : _a.getConsents({ timeout: 700 })) ?? this._cmp : {
          ...this._cmp,
          ...((_b = loginOptions == null ? void 0 : loginOptions.authorizationParams) == null ? void 0 : _b.cmp) ?? {}
        };
        (_c = loginOptions == null ? void 0 : loginOptions.authorizationParams) == null ? true : delete _c.cmp;
        if ((_d = loginOptions == null ? void 0 : loginOptions.authorizationParams) == null ? void 0 : _d.source) {
          setEvtSrc(loginOptions.authorizationParams.source);
        }
        const options = mergeObjects(
          {
            authorizationParams: {
              redirect_uri: this._coreConfig.redirectUri,
              cmp: JSON.stringify(cmp),
              universal: "v3",
              connection: this._coreConfig.connection || this._coreConfig.realm,
              realm: this._coreConfig.connection || this._coreConfig.realm
            }
          },
          loginOptions
        );
        await ((_e = this._auth0Instance) == null ? void 0 : _e.loginWithRedirect(options));
      } catch (error) {
        (_f = this.logger) == null ? void 0 : _f.errorWithContext("login", error.message, error);
        this.reportToSentry("login", error);
      }
    });
    /**
     * Checks for and handles legacy v2 session migration
     * Automatically initiates login if v2 session traces are found
     * @param loginOptions - Options for the login process if migration is needed
     * @deprecated This method is deprecated and will be removed in a future version.
     * It's only kept for backward compatibility with v2 sessions.
     */
    __publicField(this, "v2Check", async (loginOptions) => {
      var _a;
      try {
        this.checkInitialization();
        const v2Session = oldSessionCheck();
        if (v2Session) {
          await this.login(loginOptions);
        }
        const sessionMigration = safeGetStorageItem(
          sessionStorage,
          "sessionMigration"
        );
        const shouldParseResult = hasAuthParams();
        if (sessionMigration && !v2Session && shouldParseResult) {
          safeRemoveStorageItem(sessionStorage, "sessionMigration");
          await this.handleAuthentication();
        }
      } catch (error) {
        (_a = this.logger) == null ? void 0 : _a.errorWithContext("v2Check", error.message, error);
      }
    });
    /**
     * Verifies if user has an active session and refreshes tokens
     * Note: Does not guarantee authentication status
     * @param options - Options for token refresh
     */
    __publicField(this, "checkSession", async (options) => {
      var _a, _b;
      try {
        this.checkInitialization();
        return await ((_a = this._auth0Instance) == null ? void 0 : _a.checkSession(options));
      } catch (error) {
        (_b = this.logger) == null ? void 0 : _b.errorWithContext("checkSession", error.message, error);
        this.reportToSentry("checkSession", error);
      }
    });
    /**
     * Retrieves authenticated user information
     * @returns User information if authenticated, undefined otherwise
     */
    __publicField(this, "getUserInfo", async () => {
      var _a, _b, _c;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("getUserInfo");
        return await ((_b = this._auth0Instance) == null ? void 0 : _b.getUser());
      } catch (error) {
        (_c = this.logger) == null ? void 0 : _c.errorWithContext("getUserInfo", error.message, error);
        this.reportToSentry("getUserInfo", error);
      }
    });
    /**
     * Retrieves access token for authenticated user
     * @param options - Options for token retrieval
     * @returns Access token if available, undefined otherwise
     */
    __publicField(this, "getAccessToken", async (options) => {
      var _a, _b, _c;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("getAccessToken");
        const mergedOptions = mergeObjects(
          {
            authorizationParams: {
              scope: this._coreConfig.scope,
              audience: this._coreConfig.audience,
              redirect_uri: this._coreConfig.redirectUri
            }
          },
          options || {}
        );
        const token = await ((_b = this._auth0Instance) == null ? void 0 : _b.getTokenSilently(mergedOptions));
        if (token) {
          await setSessionActive({
            domain: this._coreConfig.domain,
            clientId: this._coreConfig.clientID
          });
        } else {
          await removeSessionData(this._coreConfig.domain);
        }
        return token;
      } catch (error) {
        (_c = this.logger) == null ? void 0 : _c.errorWithContext("getAccessToken", error.message, error);
      }
    });
    /**
     * Retrieves access token for authenticated user
     * @param tokenOptions - Options for token retrieval
     * @param config - Configuration for the popup
     * @returns Access token if available, undefined otherwise
     */
    __publicField(this, "getAccessTokenWithPopup", async (tokenOptions, config) => {
      var _a, _b, _c, _d, _e, _f;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("getAccessTokenWithPopup");
        const cmp = _AlmaAccountCore._cmpHandlerEnabled ? await ((_b = this._cmpHandler) == null ? void 0 : _b.getConsents({ timeout: 700 })) ?? this._cmp : {
          ...this._cmp,
          ...((_c = tokenOptions == null ? void 0 : tokenOptions.authorizationParams) == null ? void 0 : _c.cmp) ?? {}
        };
        (_d = tokenOptions == null ? void 0 : tokenOptions.authorizationParams) == null ? true : delete _d.cmp;
        const options = mergeObjects(
          {
            authorizationParams: {
              redirect_uri: this._coreConfig.redirectUri,
              cmp: JSON.stringify(cmp),
              universal: "v3",
              connection: this._coreConfig.connection || this._coreConfig.realm,
              realm: this._coreConfig.connection || this._coreConfig.realm,
              response_type: "code",
              response_mode: "web_message"
            }
          },
          tokenOptions
        );
        const token = await ((_e = this._auth0Instance) == null ? void 0 : _e.getTokenWithPopup(
          options,
          config
        ));
        if (token) {
          await setSessionActive({
            domain: this._coreConfig.domain,
            clientId: this._coreConfig.clientID
          });
        } else {
          await removeSessionData(this._coreConfig.domain);
        }
        return token;
      } catch (error) {
        (_f = this.logger) == null ? void 0 : _f.errorWithContext(
          "getAccessTokenWithPopup",
          error.message,
          error
        );
        this.reportToSentry("getAccessTokenWithPopup", error);
      }
    });
    /**
     * Checks if user is authenticated
     * @returns True if authenticated, false otherwise
     */
    __publicField(this, "isAuthenticated", async () => {
      var _a, _b, _c;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("isAuthenticated");
        const isAuthenticated = await ((_b = this._auth0Instance) == null ? void 0 : _b.isAuthenticated());
        return isAuthenticated ?? false;
      } catch (error) {
        (_c = this.logger) == null ? void 0 : _c.errorWithContext("isAuthenticated", error.message, error);
        this.reportToSentry("isAuthenticated", error);
        return false;
      }
    });
    /**
     * Handles authentication flow after user is redirected back to application
     * @returns Authenticated user information
     */
    __publicField(this, "handleAuthentication", async () => {
      var _a, _b, _c;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("handleAuthentication");
        if (hasAuthParams()) {
          const result = await ((_b = this._auth0Instance) == null ? void 0 : _b.handleRedirectCallback());
          if (result) {
            await setSessionActive({
              domain: this._coreConfig.domain,
              clientId: this._coreConfig.clientID
            });
          }
          return result;
        }
        return void 0;
      } catch (error) {
        (_c = this.logger) == null ? void 0 : _c.errorWithContext(
          "handleAuthentication",
          error.message,
          error
        );
        this.reportToSentry("handleAuthentication", error);
        return void 0;
      }
    });
    /**
     * Logs out user
     * Clears cookies and redirects user to logout callback site
     * @param returnTo - URI where browser returns after logout is completed
     * @param federated - If true, user is logged out from identity provider
     */
    __publicField(this, "logout", async (returnTo, federated = false) => {
      var _a, _b, _c;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("logout");
        if (canUseSessionStorage()) {
          safeRemoveStorageItem(sessionStorage, "evtSrc");
          safeRemoveStorageItem(sessionStorage, "sessionMigration");
        }
        await removeSessionData(this._coreConfig.domain);
        await ((_b = this._auth0Instance) == null ? void 0 : _b.logout({
          logoutParams: {
            returnTo: returnTo ?? window.location.origin,
            federated
          }
        }));
      } catch (error) {
        (_c = this.logger) == null ? void 0 : _c.errorWithContext("logout", error.message, error);
        this.reportToSentry("logout", error);
      }
    });
    /**
     * Retrieves id token for authenticated user
     * @param raw - If true, raw id token is returned
     * @returns Id token if available, undefined otherwise
     */
    __publicField(this, "getIdToken", async (raw) => {
      var _a, _b, _c;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("getIdToken");
        return await ((_b = this._auth0Instance) == null ? void 0 : _b.getIdTokenClaims().then((res) => {
          if (raw) {
            return res == null ? void 0 : res.__raw;
          }
          return res;
        }));
      } catch (error) {
        (_c = this.logger) == null ? void 0 : _c.errorWithContext("getIdToken", error.message, error);
        this.reportToSentry("getIdToken", error);
      }
    });
    /**
     * Attempts to automatically authenticate the user if they have an active SSO session.
     *
     * This method will:
     * 1. Check if the user is already authenticated
     * 2. Verify if a recent autologin attempt was made (within the throttle period)
     * 3. Attempt silent authentication via SSO if conditions are met
     *
     * The method uses localStorage or cookies to track autologin attempts to prevent
     * excessive authentication requests within a short time period.
     * The throttle period is configurable via autoLoginThrottleHours (defaults to 8 hours).
     *
     * @returns A promise that resolves when the autologin process completes
     * @throws Will not throw errors, but logs them internally
     */
    __publicField(this, "autologin", async () => {
      var _a, _b, _c, _d, _e, _f;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("autologin");
        if (await this.isAuthenticated()) {
          (_b = this.logger) == null ? void 0 : _b.infoWithContext(
            "autologin",
            "user is already authenticated"
          );
          return void 0;
        }
        const hasActiveSession = await checkActiveSession({
          domain: this._coreConfig.domain
        });
        if (!hasActiveSession) {
          (_c = this.logger) == null ? void 0 : _c.infoWithContext(
            "autologin",
            "skipping due to no active session or cookie support"
          );
          return void 0;
        }
        try {
          const token = await this.getAccessToken({
            authorizationParams: {
              disallowGroupUsers: true,
              source: "autologin"
            }
          });
          if (token) {
            const user = await this.getUserInfo();
            if (user) {
              return user;
            }
          } else {
            (_d = this.logger) == null ? void 0 : _d.infoWithContext("autologin", "getAccessToken failed");
            await removeSessionData(this._coreConfig.domain);
          }
          return void 0;
        } catch (tokenError) {
          (_e = this.logger) == null ? void 0 : _e.errorWithContext(
            "autologin",
            "silent authentication failed"
          );
          return void 0;
        }
      } catch (error) {
        (_f = this.logger) == null ? void 0 : _f.errorWithContext("autologin", error.message, error);
        return void 0;
      }
    });
    /**
     * Forces a daily session refresh for analytics tracking
     * Only refreshes if sessionRefreshCheck criteria are met
     * @returns Updated user information after refresh
     */
    __publicField(this, "dailySessionRenewal", async () => {
      var _a, _b, _c, _d, _e;
      try {
        this.checkInitialization();
        (_a = this.logger) == null ? void 0 : _a.infoWithContext("dailySessionRenewal");
        if (!await this.isAuthenticated()) {
          return void 0;
        }
        if (sessionRefreshCheck()) {
          (_b = this.logger) == null ? void 0 : _b.infoWithContext(
            "dailySessionRenewal: sessionRefreshCheck is true and user is authenticated"
          );
          await ((_c = this._auth0Instance) == null ? void 0 : _c.getTokenSilently({
            cacheMode: "off"
          }));
          return await ((_d = this._auth0Instance) == null ? void 0 : _d.getUser());
        }
      } catch (error) {
        (_e = this.logger) == null ? void 0 : _e.errorWithContext(
          "dailySessionRenewal",
          error.message,
          error
        );
      }
    });
    /**
     * Resets the AlmaAccountCore instance to its initial state
     * Clears the Auth0 instance and singleton instance
     */
    __publicField(this, "resetInstance", () => {
      this._auth0Instance = null;
      _AlmaAccountCore.instance = void 0;
    });
    /**
     * Returns the self-service password change URL
     * @param {object} [params] Optional parameters for password change request
     * @returns {Promise<Response>} The fetch response from password change request
     * @throws {Error} If Auth0 instance is not initialized
     */
    __publicField(this, "selfServicePasswordChangeUrl", async (params) => {
      var _a, _b;
      this.checkInitialization();
      const url = getSelfServiceAPIUrlWithDomain(this._coreConfig.domain);
      const user = await ((_a = this._auth0Instance) == null ? void 0 : _a.getUser());
      if (!user && !(params == null ? void 0 : params.email)) {
        throw new Error(
          "No user data found, pass the email as a parameter to the function"
        );
      }
      const requestBody = {
        data: {
          email: (user == null ? void 0 : user.email) || (params == null ? void 0 : params.email),
          clientId: this._coreConfig.clientID
        }
      };
      const passwordChangeParams = getPasswordChangeParams(
        this._coreConfig.clientID,
        params
      );
      try {
        return await fetch(
          `${url}/request_password_change?${passwordChangeParams}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(requestBody)
          }
        );
      } catch (error) {
        (_b = this.logger) == null ? void 0 : _b.errorWithContext(
          "Failed to request password change:",
          error.message,
          error
        );
        throw error;
      }
    });
    /**
     * Request email verification for the current user
     * @param {object} [params] Optional parameters for email verification request
     * @returns {Promise<boolean>} True if email verification request was successful
     * @throws {Error} If Auth0 instance is not initialized or verification request fails
     */
    __publicField(this, "selfServiceVerifyEmailUrl", async (params) => {
      var _a, _b, _c, _d;
      this.checkInitialization();
      const url = getSelfServiceAPIUrlWithDomain(this._coreConfig.domain);
      const user = await ((_a = this._auth0Instance) == null ? void 0 : _a.getUser());
      if (!(user == null ? void 0 : user.sub)) {
        (_b = this.logger) == null ? void 0 : _b.errorWithContext(
          "No user or user ID found for email verification"
        );
        throw new Error("User ID not available for email verification");
      }
      if (user.email_verified) {
        (_c = this.logger) == null ? void 0 : _c.errorWithContext("User email already verified");
        return true;
      }
      try {
        const verifyEmailParams = getVerifyEmailParams(
          this._coreConfig.clientID,
          user.sub,
          params
        );
        const response = await fetch(`${url}/verify?${verifyEmailParams}`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        });
        if (!response.ok) {
          throw new Error(
            `Email verification request failed: ${response.status}`
          );
        }
        return true;
      } catch (error) {
        (_d = this.logger) == null ? void 0 : _d.errorWithContext("Failed to request email verification:");
        throw error;
      }
    });
    /**
     * Prints the version info to the console.
     * @private
     */
    __publicField(this, "_printVersionInfo", () => {
      var _a;
      (_a = this.logger) == null ? void 0 : _a.infoWithContext("Alma Account Core Version: ", version);
    });
    /**
     * Prints the config to the console.
     * @private
     */
    __publicField(this, "_printConfig", () => {
      var _a;
      (_a = this.logger) == null ? void 0 : _a.infoWithContext(
        "Alma Account Core Config: ",
        this._coreConfig
      );
    });
    /**
     * Maps the console functions to the window object for debugging purposes.
     * @private
     * @returns {void}
     */
    __publicField(this, "_mapConsoleFunctionsToWindow", () => {
      var _a, _b;
      if (!canUseDOM()) {
        return;
      }
      try {
        const existingAlma = window.ALMA || {};
        const existingAccount = existingAlma.account || {};
        const accountFunctions = {
          printConfig: this._printConfig.bind(this),
          printVersionInfo: this._printVersionInfo.bind(this),
          selfServicePasswordChangeUrl: this.selfServicePasswordChangeUrl.bind(this),
          selfServiceVerifyEmailUrl: this.selfServiceVerifyEmailUrl.bind(this)
        };
        window.ALMA = {
          ...existingAlma,
          account: {
            ...existingAccount,
            ...accountFunctions
          }
        };
        if (!((_a = window.ALMA) == null ? void 0 : _a.account)) {
          throw new Error(
            "Failed to map console functions to window.ALMA.account"
          );
        }
      } catch (error) {
        (_b = this.logger) == null ? void 0 : _b.errorWithContext(
          "_mapConsoleFunctionsToWindow",
          error.message,
          error
        );
        this.reportToSentry("_mapConsoleFunctionsToWindow", error);
      }
    });
    this._cmpHandler = null;
    this._sentryDisabled = false;
  }
  /**
   * Reports errors to Sentry for monitoring and debugging.
   * Filters out common expected errors to reduce noise.
   * @param {string} context - The context where the error occurred
   * @param {Error} error - The error object to report
   * @returns {void}
   * @private
   */
  reportToSentry(context, error) {
    var _a;
    const ignoredErrors = [
      "Aborted",
      "Login required",
      "Popup closed",
      "Timeout",
      "Invalid state"
    ];
    const ignoredErrorPatterns = [/auth0-spa-js must run on/];
    if (ignoredErrors.includes(error.message) || ignoredErrorPatterns.some((pattern) => pattern.test(error.message))) {
      return;
    }
    if (!this._sentryDisabled && !this._sentryInstance) {
      this._sentryInstance = new BrowserMicroSentryClient({
        dsn: "https://0105128f0b0cc5f319833bca2c35a654@o1010800.ingest.sentry.io/4506194805522432",
        release: version,
        environment: "production"
      });
    }
    (_a = this._sentryInstance) == null ? void 0 : _a.captureMessage(
      `Error in ${context}: ${error.message}`
    );
  }
  /**
   * Verifies that the AlmaAccountCore instance is initialized
   * @throws {Error} If the Auth0 instance is not initialized
   */
  checkInitialization() {
    if (!this._auth0Instance) {
      throw new Error("Core instance is not initialized");
    }
  }
};
__publicField(_AlmaAccountCore, "instance");
__publicField(_AlmaAccountCore, "_cmpHandlerEnabled");
/**
 * Returns the singleton instance of AlmaAccountCore.
 * Creates a new instance if one doesn't exist and initializes logging.
 * @param {IInstanceConfig} [options] - Configuration options for the instance
 * @returns {AlmaAccountCore} The singleton instance of AlmaAccountCore
 * @public
 */
__publicField(_AlmaAccountCore, "getInstance", (options) => {
  var _a;
  if (!_AlmaAccountCore.instance) {
    _AlmaAccountCore.instance = new _AlmaAccountCore();
    if (canUseDOM()) {
      console.log("version", version);
      let loggerVersion;
      if (version.startsWith("v")) {
        loggerVersion = version;
      } else {
        loggerVersion = `v${version}`;
      }
      _AlmaAccountCore.instance.logger = new c$1(
        h$1.ACCOUNT_CORE,
        {
          moduleVersion: loggerVersion
        }
      );
      setLogger(_AlmaAccountCore.instance.logger);
      if (options == null ? void 0 : options.disableCMPHandler) {
        (_a = _AlmaAccountCore.instance.logger) == null ? void 0 : _a.warn(
          "CMP handler is disabled from options"
        );
        _AlmaAccountCore._cmpHandlerEnabled = false;
      } else {
        _AlmaAccountCore.instance._cmpHandler = AlmaAccountCmpHandler.getInstance();
        _AlmaAccountCore._cmpHandlerEnabled = true;
      }
      if (options == null ? void 0 : options.disableSentry) {
        _AlmaAccountCore.instance._sentryDisabled = true;
      }
    }
  }
  return _AlmaAccountCore.instance;
});
let AlmaAccountCore = _AlmaAccountCore;
export {
  AlmaAccountCore
};
//# sourceMappingURL=index.min.mjs.map
